// kapigen version 0.1.34
// eslint-disable
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { PrivatedModerationStatusWireFormat3 as KaggleSdkAbusePrivatedModerationStatusWireFormat3 } from "../abuse";
import { CroppedImageUploadWireFormat3 as KaggleSdkCommonCroppedImageUploadWireFormat3, DiskUsageLimitsWireFormat3 as KaggleSdkCommonDiskUsageLimitsWireFormat3, ImageWireFormat3 as KaggleSdkCommonImageWireFormat3, VoteButtonWireFormat3 as KaggleSdkCommonVoteButtonWireFormat3, VoteTypeWireFormat3 as KaggleSdkCommonVoteTypeWireFormat3 } from "../common";
import { ContentStateWireFormat3 as KaggleSdkCommunityContentStateWireFormat3 } from "../community";
import { CompetitionDatabundleTypeWireFormat3 as KaggleSdkCompetitionsCompetitionDatabundleTypeWireFormat3 } from "../competitions";
import { GetDataViewResponseWireFormat3 as KaggleSdkDatasetsDataViewerGetDataViewResponseWireFormat3, TableQueryWireFormat3 as KaggleSdkDatasetsDataViewerTableQueryWireFormat3 } from "./data_viewer";
import { DatabundleVerificationInfoWireFormat3 as KaggleSdkDatasetsDatabundlesDatabundleVerificationInfoWireFormat3, GithubInfoWireFormat3 as KaggleSdkDatasetsDatabundlesGithubInfoWireFormat3, RemoteUrlInfoWireFormat3 as KaggleSdkDatasetsDatabundlesRemoteUrlInfoWireFormat3 } from "./databundles";
import { KernelSessionOutputFileWireFormat3 as KaggleSdkKernelsKernelSessionOutputFileWireFormat3 } from "../kernels";
import { TagListWireFormat3 as KaggleSdkTagsTagListWireFormat3, TagWireFormat3 as KaggleSdkTagsTagWireFormat3 } from "../tags";
import { CollaboratorListWireFormat3 as KaggleSdkUsersCollaboratorListWireFormat3, CollaboratorTypeWireFormat3 as KaggleSdkUsersCollaboratorTypeWireFormat3, MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3, UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3, UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "../users";
// namespace Kaggle.Sdk.Datasets:
export var DatasetFileType;
(function(DatasetFileType) {
    var Enum;
    (function(Enum) {
        Enum["DATASET_FILE_TYPE_UNSPECIFIED"] = "datasetFileTypeUnspecified";
        Enum["CSV"] = "csv";
        Enum["JSON"] = "json";
        Enum["SQLITE"] = "sqlite";
        Enum["OTHER"] = "other";
    })(Enum = DatasetFileType.Enum || (DatasetFileType.Enum = {}));
    var EnumWireFormat3 = DatasetFileType.EnumWireFormat3 = {
        fromJson: function fromJson(wireFormat) {
            switch(wireFormat){
                case "DATASET_FILE_TYPE_UNSPECIFIED":
                default:
                    return Enum.DATASET_FILE_TYPE_UNSPECIFIED;
                case "CSV":
                    return Enum.CSV;
                case "JSON":
                    return Enum.JSON;
                case "SQLITE":
                    return Enum.SQLITE;
                case "OTHER":
                    return Enum.OTHER;
            }
        }
    };
})(DatasetFileType || (DatasetFileType = {}));
export var DatasetFileTypeGroup;
(function(DatasetFileTypeGroup) {
    var Enum;
    (function(Enum) {
        Enum["ALL"] = "all";
        Enum["CSV"] = "csv";
        Enum["SQLITE"] = "sqlite";
        Enum["JSON"] = "json";
        Enum["BIG_QUERY"] = "bigQuery";
    })(Enum = DatasetFileTypeGroup.Enum || (DatasetFileTypeGroup.Enum = {}));
    var EnumWireFormat3 = DatasetFileTypeGroup.EnumWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case Enum.ALL:
                case 0:
                default:
                    return "ALL";
                case Enum.CSV:
                case 1:
                    return "CSV";
                case Enum.SQLITE:
                case 2:
                    return "SQLITE";
                case Enum.JSON:
                case 3:
                    return "JSON";
                case Enum.BIG_QUERY:
                case 4:
                    return "BIG_QUERY";
            }
        }
    };
})(DatasetFileTypeGroup || (DatasetFileTypeGroup = {}));
export var DatasetLicenseGroup;
(function(DatasetLicenseGroup) {
    var Enum;
    (function(Enum) {
        Enum["ALL"] = "all";
        Enum["CC"] = "cc";
        Enum["GPL"] = "gpl";
        Enum["ODB"] = "odb";
        Enum["OTHER"] = "other";
    })(Enum = DatasetLicenseGroup.Enum || (DatasetLicenseGroup.Enum = {}));
    var EnumWireFormat3 = DatasetLicenseGroup.EnumWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case Enum.ALL:
                case 0:
                default:
                    return "ALL";
                case Enum.CC:
                case 1:
                    return "CC";
                case Enum.GPL:
                case 2:
                    return "GPL";
                case Enum.ODB:
                case 3:
                    return "ODB";
                case Enum.OTHER:
                case 4:
                    return "OTHER";
            }
        }
    };
})(DatasetLicenseGroup || (DatasetLicenseGroup = {}));
export var DatasetSelectionGroup;
(function(DatasetSelectionGroup) {
    var Enum;
    (function(Enum) {
        Enum["PUBLIC"] = "public";
        Enum["MY"] = "my";
        Enum["USER"] = "user";
        Enum["USER_SHARED_WITH_ME"] = "userSharedWithMe";
        Enum["UPVOTED"] = "upvoted";
        Enum["MY_PRIVATE"] = "myPrivate";
        Enum["MY_PUBLIC"] = "myPublic";
        Enum["ORGANIZATION"] = "organization";
        Enum["BOOKMARKED"] = "bookmarked";
        Enum["COLLABORATION"] = "collaboration";
        Enum["SHARED_WITH_USER"] = "sharedWithUser";
        Enum[// Old
        "FEATURED"] = "featured";
        Enum["ALL"] = "all";
        Enum["UNFEATURED"] = "unfeatured";
    })(Enum = DatasetSelectionGroup.Enum || (DatasetSelectionGroup.Enum = {}));
    var EnumWireFormat3 = DatasetSelectionGroup.EnumWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case Enum.PUBLIC:
                case 0:
                default:
                    return "PUBLIC";
                case Enum.MY:
                case 1:
                    return "MY";
                case Enum.USER:
                case 2:
                    return "USER";
                case Enum.USER_SHARED_WITH_ME:
                case 3:
                    return "USER_SHARED_WITH_ME";
                case Enum.UPVOTED:
                case 4:
                    return "UPVOTED";
                case Enum.MY_PRIVATE:
                case 5:
                    return "MY_PRIVATE";
                case Enum.MY_PUBLIC:
                case 10:
                    return "MY_PUBLIC";
                case Enum.ORGANIZATION:
                case 6:
                    return "ORGANIZATION";
                case Enum.BOOKMARKED:
                case 11:
                    return "BOOKMARKED";
                case Enum.COLLABORATION:
                case 12:
                    return "COLLABORATION";
                case Enum.SHARED_WITH_USER:
                case 13:
                    return "SHARED_WITH_USER";
                case Enum.FEATURED:
                case 7:
                    return "FEATURED";
                case Enum.ALL:
                case 8:
                    return "ALL";
                case Enum.UNFEATURED:
                case 9:
                    return "UNFEATURED";
            }
        }
    };
})(DatasetSelectionGroup || (DatasetSelectionGroup = {}));
export var DatasetSizeGroup;
(function(DatasetSizeGroup) {
    var Enum;
    (function(Enum) {
        Enum["ALL"] = "all";
        Enum["SMALL"] = "small";
        Enum["MEDIUM"] = "medium";
        Enum["LARGE"] = "large";
    })(Enum = DatasetSizeGroup.Enum || (DatasetSizeGroup.Enum = {}));
    var EnumWireFormat3 = DatasetSizeGroup.EnumWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case Enum.ALL:
                case 0:
                default:
                    return "ALL";
                case Enum.SMALL:
                case 1:
                    return "SMALL";
                case Enum.MEDIUM:
                case 2:
                    return "MEDIUM";
                case Enum.LARGE:
                case 3:
                    return "LARGE";
            }
        }
    };
})(DatasetSizeGroup || (DatasetSizeGroup = {}));
export var DatasetSortBy;
(function(DatasetSortBy) {
    var Enum;
    (function(Enum) {
        Enum["HOTTEST"] = "hottest";
        Enum["VOTES"] = "votes";
        Enum["UPDATED"] = "updated";
        Enum[// Deprecated
        "ACTIVE"] = "active";
        Enum["PUBLISHED"] = "published";
        Enum[// Old world
        "RELEVANCE"] = "relevance";
        Enum["LAST_VIEWED"] = "lastViewed";
        Enum["USABILITY"] = "usability";
    })(Enum = DatasetSortBy.Enum || (DatasetSortBy.Enum = {}));
    var EnumWireFormat3 = DatasetSortBy.EnumWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case Enum.HOTTEST:
                case 0:
                default:
                    return "HOTTEST";
                case Enum.VOTES:
                case 1:
                    return "VOTES";
                case Enum.UPDATED:
                case 2:
                    return "UPDATED";
                case Enum.ACTIVE:
                case 3:
                    return "ACTIVE";
                case Enum.PUBLISHED:
                case 4:
                    return "PUBLISHED";
                case Enum.RELEVANCE:
                case 5:
                    return "RELEVANCE";
                case Enum.LAST_VIEWED:
                case 6:
                    return "LAST_VIEWED";
                case Enum.USABILITY:
                case 7:
                    return "USABILITY";
            }
        }
    };
})(DatasetSortBy || (DatasetSortBy = {}));
export var DatasetViewedGroup;
(function(DatasetViewedGroup) {
    var Enum;
    (function(Enum) {
        Enum["ALL"] = "all";
        Enum["VIEWED"] = "viewed";
    })(Enum = DatasetViewedGroup.Enum || (DatasetViewedGroup.Enum = {}));
    var EnumWireFormat3 = DatasetViewedGroup.EnumWireFormat3 = {
        toJson: function toJson(enumVal) {
            switch(enumVal){
                case Enum.ALL:
                case 0:
                default:
                    return "ALL";
                case Enum.VIEWED:
                case 1:
                    return "VIEWED";
            }
        }
    };
})(DatasetViewedGroup || (DatasetViewedGroup = {}));
export var ActionFlagsWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultActivityNotGeneratedBanner = {};
export var ActivityNotGeneratedBannerWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityNotGeneratedBanner, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.img) {
            message.img = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.img);
        }
        return message;
    }
};
var defaultActivityPage = {};
export var ActivityPageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityPage, wireFormat);
        if (wireFormat) {
            message.status = ActivityPageStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.banner) {
            message.banner = ActivityNotGeneratedBannerWireFormat3.fromJson(wireFormat.banner);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.summaryStats) {
            message.summaryStats = ActivitySummaryStatsWireFormat3.fromJson(wireFormat.summaryStats);
        }
        return message;
    }
};
var defaultActivityPageContributorLocation = {
    count: 0
};
export var ActivityPageContributorLocationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityPageContributorLocation, wireFormat);
        return message;
    }
};
var defaultActivityPageTimeSeries = {
    points: []
};
export var ActivityPageTimeSeriesWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityPageTimeSeries, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.points) {
            message.points = wireFormat.points.map(function(i) {
                return ActivityPageTimeSeriesPointWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultActivityPageTimeSeriesPoint = {
    count: 0
};
export var ActivityPageTimeSeriesPointWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivityPageTimeSeriesPoint, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        return message;
    }
};
var defaultActivitySummaryStats = {
    id: 0,
    schemaVersion: 0,
    datasetId: 0,
    datasetStats: [],
    timeSeries: {},
    topContributors: [],
    contributorLocations: [],
    kernelStats: [],
    kernelMedals: [],
    topKernels: [],
    tags: [],
    relatedDatasets: [],
    discussionStats: [],
    discussionMedals: [],
    topDiscussions: []
};
export var ActivitySummaryStatsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultActivitySummaryStats, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.generatedDate) {
            message.generatedDate = new Date(wireFormat.generatedDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetStats) {
            message.datasetStats = wireFormat.datasetStats.map(function(i) {
                return DatasetActivityPageStatWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeSeries) {
            message.timeSeries = {};
            Object.entries(wireFormat.timeSeries).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                message.timeSeries[key] = ActivityPageTimeSeriesWireFormat3.fromJson(value);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topContributors) {
            message.topContributors = wireFormat.topContributors.map(function(i) {
                return DatasetActivityPageContributorWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contributorLocations) {
            message.contributorLocations = wireFormat.contributorLocations.map(function(i) {
                return ActivityPageContributorLocationWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelStats) {
            message.kernelStats = wireFormat.kernelStats.map(function(i) {
                return DatasetActivityPageStatWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelMedals) {
            message.kernelMedals = wireFormat.kernelMedals.map(function(i) {
                return DatasetActivityPageMedalWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topKernels) {
            message.topKernels = wireFormat.topKernels.map(function(i) {
                return DatasetActivityPageKernelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return DatasetActivityPageTagWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.relatedDatasets) {
            message.relatedDatasets = wireFormat.relatedDatasets.map(function(i) {
                return DatasetActivityPageRelatedDatasetWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussionStats) {
            message.discussionStats = wireFormat.discussionStats.map(function(i) {
                return DatasetActivityPageStatWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.discussionMedals) {
            message.discussionMedals = wireFormat.discussionMedals.map(function(i) {
                return DatasetActivityPageMedalWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topDiscussions) {
            message.topDiscussions = wireFormat.topDiscussions.map(function(i) {
                return DatasetActivityPageDiscussionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var AddDatasetCategoriesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultAddDatasetCategoriesResponse = {};
export var AddDatasetCategoriesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAddDatasetCategoriesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedUsabilityRating) {
            message.updatedUsabilityRating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.updatedUsabilityRating);
        }
        return message;
    }
};
var defaultAutoGeneratedSource = {};
export var AutoGeneratedSourceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAutoGeneratedSource, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelReference) {
            message.kernelReference = KernelOutputKernelReferenceWireFormat3.fromJson(wireFormat.kernelReference);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.kernelReference) {
            wireFormat.kernelReference = KernelOutputKernelReferenceWireFormat3.toJson(message.kernelReference);
        }
        return wireFormat;
    }
};
var defaultBasicKernelOutputKernelReference = {
    url: ""
};
export var BasicKernelOutputKernelReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBasicKernelOutputKernelReference, wireFormat);
        return message;
    }
};
var defaultCompetitionDatabundleVersion = {
    id: 0,
    databundleId: 0,
    creatorUserId: 0
};
export var CompetitionDatabundleVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionDatabundleVersion, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
            message.creationDate = new Date(wireFormat.creationDate);
        }
        if (wireFormat) {
            message.type = DatabundleVersionTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat) {
            message.status = DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationStatus) {
            message.creationStatus = DatabundleVersionCreationStatusWireFormat3.fromJson(wireFormat.creationStatus);
        }
        return message;
    }
};
var defaultCompetitionUploaderConfig = {};
export var CompetitionUploaderConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionUploaderConfig, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingData) {
            message.existingData = ExistingDataInfoWireFormat3.fromJson(wireFormat.existingData);
        }
        return message;
    }
};
export var ConsentToUserLicenseAgreementRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateBigQueryDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.basicInfo) {
            wireFormat.basicInfo = DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
        }
        return wireFormat;
    }
};
export var CreateCompetitionDataRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.basicInfo) {
            wireFormat.basicInfo = DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.existingDirectories) {
            wireFormat.existingDirectories = message.existingDirectories.map(function(i) {
                return ExistingDirectoryInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.existingFiles) {
            wireFormat.existingFiles = message.existingFiles.map(function(i) {
                return ExistingFileInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.competitionDatabundleType) {
            wireFormat.competitionDatabundleType = KaggleSdkCompetitionsCompetitionDatabundleTypeWireFormat3.toJson(message.competitionDatabundleType);
        }
        return wireFormat;
    }
};
var defaultCreateCompetitionDataResponse = {};
export var CreateCompetitionDataResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateCompetitionDataResponse, wireFormat);
        if (wireFormat) {
            message.status = CreationStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersionReference) {
            message.databundleVersionReference = DatabundleVersionReferenceWireFormat3.fromJson(wireFormat.databundleVersionReference);
        }
        return message;
    }
};
export var CreateDatasetHashLinkRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateDatasetHashLinkResponse = {
    datasetHashLink: ""
};
export var CreateDatasetHashLinkResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateDatasetHashLinkResponse, wireFormat);
        return message;
    }
};
export var CreateDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.basicInfo) {
            wireFormat.basicInfo = DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
        }
        return wireFormat;
    }
};
export var CreateDatasetVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.basicInfo) {
            wireFormat.basicInfo = DataCreationBasicInfoWireFormat3.toJson(message.basicInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.existingDirectories) {
            wireFormat.existingDirectories = message.existingDirectories.map(function(i) {
                return ExistingDirectoryInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.existingFiles) {
            wireFormat.existingFiles = message.existingFiles.map(function(i) {
                return ExistingFileInfoWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var CreateDoiRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateDoiResponse = {};
export var CreateDoiResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateDoiResponse, wireFormat);
        return message;
    }
};
var defaultDatabundleInfo = {
    totalSize: 0,
    isFileset: false,
    canDownload: false,
    canUpdate: false,
    firestorePath: "",
    downloadUrl: "",
    versionId: 0,
    id: 0
};
export var DatabundleInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalSize) {
            message.totalSize = parseInt(wireFormat.totalSize);
        }
        return message;
    }
};
var defaultDatabundleVersionCreationStatus = {
    creationPercentComplete: 0
};
export var DatabundleVersionCreationStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleVersionCreationStatus, wireFormat);
        if (wireFormat) {
            message.status = DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationPercentComplete) != undefined) {
            message.creationPercentComplete = Number(wireFormat.creationPercentComplete);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationLastUpdate) {
            message.creationLastUpdate = new Date(wireFormat.creationLastUpdate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationStart) {
            message.creationStart = new Date(wireFormat.creationStart);
        }
        return message;
    }
};
var defaultDatabundleVersionReference = {
    databundleId: 0,
    databundleVersionId: 0
};
export var DatabundleVersionReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatabundleVersionReference, wireFormat);
        if (wireFormat) {
            message.databundleType = DatabundleTypeWireFormat3.fromJson(wireFormat.databundleType);
        }
        if (wireFormat) {
            message.databundleVersionType = DatabundleVersionTypeWireFormat3.fromJson(wireFormat.databundleVersionType);
        }
        if (wireFormat) {
            message.diffType = DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
        }
        return message;
    }
};
var defaultDataCoverageAttribute = {};
export var DataCoverageAttributeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataCoverageAttribute, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.temporalCoverageFrom) {
            message.temporalCoverageFrom = new Date(wireFormat.temporalCoverageFrom);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.temporalCoverageTo) {
            message.temporalCoverageTo = new Date(wireFormat.temporalCoverageTo);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.temporalCoverageFrom) {
            wireFormat.temporalCoverageFrom = message.temporalCoverageFrom.toISOString();
        }
        if (message === null || message === void 0 ? void 0 : message.temporalCoverageTo) {
            wireFormat.temporalCoverageTo = message.temporalCoverageTo.toISOString();
        }
        return wireFormat;
    }
};
export var DataCreationBasicInfoWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.databundleVersionType) {
            wireFormat.databundleVersionType = DatabundleVersionTypeWireFormat3.toJson(message.databundleVersionType);
        }
        if (message === null || message === void 0 ? void 0 : message.directories) {
            wireFormat.directories = message.directories.map(function(i) {
                return UploadDirectoryInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.files) {
            wireFormat.files = message.files.map(function(i) {
                return UploadFileInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.remoteUrlInfos) {
            wireFormat.remoteUrlInfos = message.remoteUrlInfos.map(function(i) {
                return KaggleSdkDatasetsDatabundlesRemoteUrlInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.githubInfo) {
            wireFormat.githubInfo = KaggleSdkDatasetsDatabundlesGithubInfoWireFormat3.toJson(message.githubInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.kernelOutputInfo) {
            wireFormat.kernelOutputInfo = UploadKernelOutputInfoWireFormat3.toJson(message.kernelOutputInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.gcsFileSetInfo) {
            wireFormat.gcsFileSetInfo = GcsFileSetInfoWireFormat3.toJson(message.gcsFileSetInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.flags) {
            wireFormat.flags = ActionFlagsWireFormat3.toJson(message.flags);
        }
        return wireFormat;
    }
};
export var DataCreationSettingsWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDatasetActivityPageContributor = {
    totalUpvotesCount: 0
};
export var DatasetActivityPageContributorWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageContributor, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
            message.user = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.user);
        }
        return message;
    }
};
var defaultDatasetActivityPageDiscussion = {
    id: 0,
    replyCount: 0
};
export var DatasetActivityPageDiscussionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageDiscussion, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButtonDto) {
            message.voteButtonDto = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButtonDto);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.avatar) {
            message.avatar = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.avatar);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.medal) {
            message.medal = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.medal);
        }
        return message;
    }
};
var defaultDatasetActivityPageKernel = {
    id: 0,
    tags: []
};
export var DatasetActivityPageKernelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageKernel, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButtonDto) {
            message.voteButtonDto = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButtonDto);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.avatar) {
            message.avatar = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.avatar);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.medal) {
            message.medal = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return KaggleSdkTagsTagWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatasetActivityPageMedal = {
    count: 0
};
export var DatasetActivityPageMedalWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageMedal, wireFormat);
        if (wireFormat) {
            message.type = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.image) {
            message.image = KaggleSdkCommonImageWireFormat3.fromJson(wireFormat.image);
        }
        return message;
    }
};
var defaultDatasetActivityPageRelatedDataset = {
    id: 0,
    kernelsCount: 0
};
export var DatasetActivityPageRelatedDatasetWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageRelatedDataset, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButtonDto) {
            message.voteButtonDto = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButtonDto);
        }
        return message;
    }
};
var defaultDatasetActivityPageStat = {
    value: 0
};
export var DatasetActivityPageStatWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageStat, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.value) != undefined) {
            message.value = Number(wireFormat.value);
        }
        return message;
    }
};
var defaultDatasetActivityPageTag = {
    kernelCount: 0
};
export var DatasetActivityPageTagWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetActivityPageTag, wireFormat);
        return message;
    }
};
var defaultDatasetAdminSettingsInfo = {
    slug: ""
};
export var DatasetAdminSettingsInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetAdminSettingsInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maintainerOrganization) {
            message.maintainerOrganization = OwnerWireFormat3.fromJson(wireFormat.maintainerOrganization);
        }
        return message;
    }
};
var defaultDatasetBasics = {
    datasetId: 0,
    slug: "",
    title: "",
    removed: false,
    private: false,
    description: "",
    viewCount: 0,
    downloadCount: 0,
    scriptCount: 0,
    topicCount: 0,
    overview: "",
    canEdit: false,
    coverImageUrl: "",
    voteCount: 0,
    medalUrl: "",
    downloadUrl: "",
    datasetVersionNumber: 0,
    alreadyVotedUp: false,
    inFlight: false,
    creatorDisplayName: "",
    cardImageUrl: "",
    bookmarked: false,
    datasetExternalUrl: "",
    ownerTwitter: "",
    collaborator: false,
    forumId: 0,
    datasetVersionId: 0,
    canCreateTasks: false,
    isReportedBannerDismissed: false,
    canPerformAdminTasks: false,
    datasetHashLink: "",
    lastVersionNumber: 0,
    showAdminAllowlist: false,
    isReportedModalDismissed: false,
    canDelete: false
};
export var DatasetBasicsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetBasics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
            message.owner = OwnerWireFormat3.fromJson(wireFormat.owner);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
            message.license = LicenseWireFormat3.fromJson(wireFormat.license);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creatorKernel) {
            message.creatorKernel = BasicKernelOutputKernelReferenceWireFormat3.fromJson(wireFormat.creatorKernel);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
            message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.data) {
            message.data = DatabundleInfoWireFormat3.fromJson(wireFormat.data);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastUpdateTime) {
            message.lastUpdateTime = new Date(wireFormat.lastUpdateTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = KaggleSdkTagsTagListWireFormat3.fromJson(wireFormat.categories);
        }
        if (wireFormat) {
            message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
        }
        if (wireFormat) {
            message.diffType = DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
        }
        if (wireFormat) {
            message.contentState = KaggleSdkCommunityContentStateWireFormat3.fromJson(wireFormat.contentState);
        }
        return message;
    }
};
var defaultDatasetCreationResponse = {};
export var DatasetCreationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetCreationResponse, wireFormat);
        if (wireFormat) {
            message.status = CreationStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.databundleVersionReference) {
            message.databundleVersionReference = DatabundleVersionReferenceWireFormat3.fromJson(wireFormat.databundleVersionReference);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetVersionReference) {
            message.datasetVersionReference = DatasetVersionReferenceWireFormat3.fromJson(wireFormat.datasetVersionReference);
        }
        return message;
    }
};
var defaultDatasetDatasourceListItem = {
    datasetId: 0,
    currentDatasetVersionId: 0,
    isPrivate: false,
    isDeleted: false
};
export var DatasetDatasourceListItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetDatasourceListItem, wireFormat);
        if (wireFormat) {
            message.type = DatabundleVersionTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat) {
            message.diffType = DatabundleDiffTypeWireFormat3.fromJson(wireFormat.diffType);
        }
        return message;
    }
};
var defaultDatasetFeedbackInfo = {
    id: 0,
    name: "",
    count: 0
};
export var DatasetFeedbackInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetFeedbackInfo, wireFormat);
        if (wireFormat) {
            message.state = FeedbackStateWireFormat3.fromJson(wireFormat.state);
        }
        if (wireFormat) {
            message.type = FeedbackTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultDatasetFileSummary = {
    count: 0,
    totalSize: 0
};
export var DatasetFileSummaryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetFileSummary, wireFormat);
        if (wireFormat) {
            message.fileType = DatasetFileType.EnumWireFormat3.fromJson(wireFormat.fileType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalSize) {
            message.totalSize = parseInt(wireFormat.totalSize);
        }
        return message;
    }
};
var defaultDatasetForReview = {
    datasetId: 0
};
export var DatasetForReviewWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetForReview, wireFormat);
        return message;
    }
};
var defaultDatasetHistory = {
    items: [],
    totalItems: 0
};
export var DatasetHistoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetHistory, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
            message.items = wireFormat.items.map(function(i) {
                return DatasetHistoryItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatasetHistoryItem = {
    changes: []
};
export var DatasetHistoryItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetHistoryItem, wireFormat);
        if (wireFormat) {
            message.type = DatasetsActivityTypeEnumWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
            message.user = OwnerDtoWireFormat3.fromJson(wireFormat.user);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.changes) {
            message.changes = wireFormat.changes.map(function(i) {
                return DatasetSchemaDiffWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.summary) {
            message.summary = DatasetSchemaDiffSummaryWireFormat3.fromJson(wireFormat.summary);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versionInfo) {
            message.versionInfo = DatasetHistoryVersionInfoWireFormat3.fromJson(wireFormat.versionInfo);
        }
        return message;
    }
};
var defaultDatasetHistoryVersionInfo = {
    databundleVersionId: 0
};
export var DatasetHistoryVersionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetHistoryVersionInfo, wireFormat);
        if (wireFormat) {
            message.status = DatabundleVersionStatusWireFormat3.fromJson(wireFormat.status);
        }
        return message;
    }
};
var defaultDatasetImageInfo = {
    cardImageUrl: "",
    cardImageLeft: 0,
    cardImageTop: 0,
    cardImageHeight: 0,
    cardImageWidth: 0,
    coverImageLeft: 0,
    coverImageHeight: 0,
    coverImageTop: 0,
    coverImageWidth: 0,
    coverImageUrl: "",
    originalImageUrl: "",
    thumbnailImageUrl: ""
};
export var DatasetImageInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetImageInfo, wireFormat);
        return message;
    }
};
var defaultDatasetList = {
    items: []
};
export var DatasetListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
            message.items = wireFormat.items.map(function(i) {
                return DatasetListItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatasetListItem = {
    datasetUrl: "",
    ownerAvatarUrl: "",
    ownerName: "",
    ownerUrl: "",
    creatorName: "",
    creatorUrl: "",
    creatorUserId: 0,
    scriptCount: 0,
    scriptsUrl: "",
    topicCount: 0,
    forumUrl: "",
    viewCount: 0,
    downloadCount: 0,
    fileCount: 0,
    isHidden: false,
    isFailed: false,
    bookmarked: false,
    isCollaborator: false,
    categories: [],
    licenseName: "",
    licenseShortName: "",
    commonFileTypes: [],
    downloadUrl: "",
    newKernelNotebookUrl: "",
    newKernelScriptUrl: "",
    description: "",
    rank: 0,
    hasHashLink: false
};
export var DatasetListItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetListItem, wireFormat);
        if (wireFormat) {
            message.ownerTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.ownerTier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateUpdated) {
            message.dateUpdated = new Date(wireFormat.dateUpdated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButton) {
            message.voteButton = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButton);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = wireFormat.categories.map(function(i) {
                return KaggleSdkTagsTagWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetSize) {
            message.datasetSize = parseInt(wireFormat.datasetSize);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.commonFileTypes) {
            message.commonFileTypes = wireFormat.commonFileTypes.map(function(i) {
                return DatasetFileSummaryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maintainerOrganization) {
            message.maintainerOrganization = OwnerDtoWireFormat3.fromJson(wireFormat.maintainerOrganization);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
            message.usabilityRating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasource) {
            message.datasource = DatasetDatasourceListItemWireFormat3.fromJson(wireFormat.datasource);
        }
        return message;
    }
};
var defaultDatasetMaterialDto = {
    isNewTopic: false
};
export var DatasetMaterialDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetMaterialDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.basics) {
            message.basics = DatasetBasicsWireFormat3.fromJson(wireFormat.basics);
        }
        if (wireFormat) {
            message.currentTab = DatasetTabWireFormat3.fromJson(wireFormat.currentTab);
        }
        return message;
    }
};
var defaultDatasetMetadata = {
    autoGeneratedSources: [],
    datasetId: 0,
    datasetVersionAuthors: [],
    datasetVersionId: 0,
    hasHashLink: false,
    isDatasetDoiApproved: false,
    isEditable: false,
    isPrivate: false,
    licenseGroups: [],
    licenseId: 0
};
export var DatasetMetadataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetMetadata, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.autoGeneratedSources) {
            message.autoGeneratedSources = wireFormat.autoGeneratedSources.map(function(i) {
                return AutoGeneratedSourceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
            message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
        }
        if (wireFormat) {
            message.databundleDiffType = DatabundleDiffTypeWireFormat3.fromJson(wireFormat.databundleDiffType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataCoverageAttribute) {
            message.dataCoverageAttribute = DataCoverageAttributeWireFormat3.fromJson(wireFormat.dataCoverageAttribute);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetCreationTimestamp) {
            message.datasetCreationTimestamp = new Date(wireFormat.datasetCreationTimestamp);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetVersionAuthors) {
            message.datasetVersionAuthors = wireFormat.datasetVersionAuthors.map(function(i) {
                return DatasetVersionAuthorWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.expectedUpdateFrequency) {
            message.expectedUpdateFrequency = ExpectedUpdateFrequencyWireFormat3.fromJson(wireFormat.expectedUpdateFrequency);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastDataUpdatedTimestamp) {
            message.lastDataUpdatedTimestamp = new Date(wireFormat.lastDataUpdatedTimestamp);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseGroups) {
            message.licenseGroups = wireFormat.licenseGroups.map(function(i) {
                return LicenseGroupDtoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatasetSchemaDiff = {};
export var DatasetSchemaDiffWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetSchemaDiff, wireFormat);
        if (wireFormat) {
            message.action = DatasetSchemaDiffActionWireFormat3.fromJson(wireFormat.action);
        }
        if (wireFormat) {
            message.level = DatasetSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.level);
        }
        if (wireFormat) {
            message.parentLevel = DatasetSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.parentLevel);
        }
        return message;
    }
};
var defaultDatasetSchemaDiffSummary = {
    addedCount: 0,
    modifiedCount: 0,
    deletedCount: 0,
    totalChangedEntities: 0,
    changedEntities: []
};
export var DatasetSchemaDiffSummaryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetSchemaDiffSummary, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.changedEntities) {
            message.changedEntities = wireFormat.changedEntities.map(function(i) {
                return DatasetSchemaEntityWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatasetSchemaEntity = {};
export var DatasetSchemaEntityWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetSchemaEntity, wireFormat);
        if (wireFormat) {
            message.level = DatasetSchemaDiffContainerLevelWireFormat3.fromJson(wireFormat.level);
        }
        return message;
    }
};
var defaultDatasetSettings = {
    isPrivate: false,
    keywords: [],
    licenses: [],
    collaborators: [],
    data: []
};
export var DatasetSettingsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetSettings, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenses) {
            message.licenses = wireFormat.licenses.map(function(i) {
                return SettingsLicenseWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
            message.collaborators = wireFormat.collaborators.map(function(i) {
                return UserRoleWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.data) {
            message.data = wireFormat.data.map(function(i) {
                return DatasetSettingsFileWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.licenses) {
            wireFormat.licenses = message.licenses.map(function(i) {
                return SettingsLicenseWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.collaborators) {
            wireFormat.collaborators = message.collaborators.map(function(i) {
                return UserRoleWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.data) {
            wireFormat.data = message.data.map(function(i) {
                return DatasetSettingsFileWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultDatasetSettingsFile = {
    name: "",
    totalBytes: 0,
    columns: []
};
export var DatasetSettingsFileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetSettingsFile, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
            message.totalBytes = parseInt(wireFormat.totalBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columns) {
            message.columns = wireFormat.columns.map(function(i) {
                return DatasetSettingsFileColumnWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.totalBytes) {
            wireFormat.totalBytes = message.totalBytes.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.columns) {
            wireFormat.columns = message.columns.map(function(i) {
                return DatasetSettingsFileColumnWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultDatasetSettingsFileColumn = {
    name: ""
};
export var DatasetSettingsFileColumnWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetSettingsFileColumn, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDatasetTopicContent = {
    datasets: []
};
export var DatasetTopicContentWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetTopicContent, wireFormat);
        if (wireFormat) {
            message.topicType = DatasetTopicEnumWireFormat3.fromJson(wireFormat.topicType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasets) {
            message.datasets = wireFormat.datasets.map(function(i) {
                return DatasetListItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultDatasetUploaderConfig = {
    licenseGroups: []
};
export var DatasetUploaderConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetUploaderConfig, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingData) {
            message.existingData = ExistingDataInfoWireFormat3.fromJson(wireFormat.existingData);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseGroups) {
            message.licenseGroups = wireFormat.licenseGroups.map(function(i) {
                return LicenseGroupDtoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.limits) {
            message.limits = KaggleSdkCommonDiskUsageLimitsWireFormat3.fromJson(wireFormat.limits);
        }
        return message;
    }
};
var defaultDatasetUsabilityRating = {
    score: 0,
    coverImageScore: 0,
    fileDescriptionScore: 0,
    fileFormatScore: 0,
    licenseScore: 0,
    overviewScore: 0,
    provenanceScore: 0,
    publicKernelScore: 0,
    subtitleScore: 0,
    tagScore: 0,
    updateFrequencyScore: 0
};
export var DatasetUsabilityRatingWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetUsabilityRating, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
            message.score = Number(wireFormat.score);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.columnDescriptionScore) != undefined) {
            message.columnDescriptionScore = Number(wireFormat.columnDescriptionScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.coverImageScore) != undefined) {
            message.coverImageScore = Number(wireFormat.coverImageScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileDescriptionScore) != undefined) {
            message.fileDescriptionScore = Number(wireFormat.fileDescriptionScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.fileFormatScore) != undefined) {
            message.fileFormatScore = Number(wireFormat.fileFormatScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenseScore) != undefined) {
            message.licenseScore = Number(wireFormat.licenseScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.overviewScore) != undefined) {
            message.overviewScore = Number(wireFormat.overviewScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.provenanceScore) != undefined) {
            message.provenanceScore = Number(wireFormat.provenanceScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicKernelScore) != undefined) {
            message.publicKernelScore = Number(wireFormat.publicKernelScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.subtitleScore) != undefined) {
            message.subtitleScore = Number(wireFormat.subtitleScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tagScore) != undefined) {
            message.tagScore = Number(wireFormat.tagScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updateFrequencyScore) != undefined) {
            message.updateFrequencyScore = Number(wireFormat.updateFrequencyScore);
        }
        return message;
    }
};
var defaultDatasetVersionAuthor = {};
export var DatasetVersionAuthorWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetVersionAuthor, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDatasetVersionReference = {
    datasetId: 0,
    datasetVersionId: 0
};
export var DatasetVersionReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDatasetVersionReference, wireFormat);
        return message;
    }
};
export var DeleteDatasetBySlugRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteDatasetCategoriesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteDatasetCategoriesResponse = {};
export var DeleteDatasetCategoriesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteDatasetCategoriesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedUsabilityRating) {
            message.updatedUsabilityRating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.updatedUsabilityRating);
        }
        return message;
    }
};
export var DeleteDatasetHashLinkRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteDataViewerCacheEntryExternalRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.tableQuery) {
            wireFormat.tableQuery = KaggleSdkDatasetsDataViewerTableQueryWireFormat3.toJson(message.tableQuery);
        }
        return wireFormat;
    }
};
export var DetectDuplicateRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDuplicationReference = {
    id: 0
};
export var DuplicationReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDuplicationReference, wireFormat);
        if (wireFormat) {
            message.type = DuplicationReferenceTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
export var EditDatasetDescriptionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultEditDatasetDescriptionResponse = {};
export var EditDatasetDescriptionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEditDatasetDescriptionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
            message.usabilityRating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
        }
        return message;
    }
};
var defaultExistingDataInfo = {
    existingUploadDirectories: [],
    existingUploadFiles: [],
    existingRemoteUrls: []
};
export var ExistingDataInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExistingDataInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingUploadDirectories) {
            message.existingUploadDirectories = wireFormat.existingUploadDirectories.map(function(i) {
                return ExistingDirectoryInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingUploadFiles) {
            message.existingUploadFiles = wireFormat.existingUploadFiles.map(function(i) {
                return ExistingFileInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.existingRemoteUrls) {
            message.existingRemoteUrls = wireFormat.existingRemoteUrls.map(function(i) {
                return KaggleSdkDatasetsDatabundlesRemoteUrlInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultExistingDirectoryInfo = {
    name: "",
    directories: [],
    files: []
};
export var ExistingDirectoryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExistingDirectoryInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directories) {
            message.directories = wireFormat.directories.map(function(i) {
                return ExistingDirectoryInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
            message.files = wireFormat.files.map(function(i) {
                return ExistingFileInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.directories) {
            wireFormat.directories = message.directories.map(function(i) {
                return ExistingDirectoryInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.files) {
            wireFormat.files = message.files.map(function(i) {
                return ExistingFileInfoWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultExistingFileInfo = {
    name: "",
    size: 0
};
export var ExistingFileInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExistingFileInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
            message.size = parseInt(wireFormat.size);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.legacyInfo) {
            message.legacyInfo = LegacyExistingFileInfoWireFormat3.fromJson(wireFormat.legacyInfo);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.size) {
            wireFormat.size = message.size.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.legacyInfo) {
            wireFormat.legacyInfo = LegacyExistingFileInfoWireFormat3.toJson(message.legacyInfo);
        }
        return wireFormat;
    }
};
var defaultExpectedUpdateFrequency = {
    isAutoUpdatedTypedDataset: false,
    updateFrequency: ""
};
export var ExpectedUpdateFrequencyWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExpectedUpdateFrequency, wireFormat);
        return message;
    }
};
export var GcsFileSetInfoWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetCompetitionUploaderConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.competitionDatabundleType) {
            wireFormat.competitionDatabundleType = KaggleSdkCompetitionsCompetitionDatabundleTypeWireFormat3.toJson(message.competitionDatabundleType);
        }
        return wireFormat;
    }
};
export var GetDatabundleVersionCreationStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetActivityRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetAdminSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatasetAdminSettingsResponse = {};
export var GetDatasetAdminSettingsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetAdminSettingsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.info) {
            message.info = DatasetAdminSettingsInfoWireFormat3.fromJson(wireFormat.info);
        }
        return message;
    }
};
export var GetDatasetBasicsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetByUrlRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultGetDatasetByUrlResponse = {};
export var GetDatasetByUrlResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetByUrlResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataset) {
            message.dataset = DatasetListItemWireFormat3.fromJson(wireFormat.dataset);
        }
        return message;
    }
};
export var GetDatasetFeedbacksRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatasetFeedbacksResponse = {
    feedbacks: []
};
export var GetDatasetFeedbacksResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetFeedbacksResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.feedbacks) {
            message.feedbacks = wireFormat.feedbacks.map(function(i) {
                return DatasetFeedbackInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetDatasetHistoryRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetImageInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatasetImageInfoResponse = {};
export var GetDatasetImageInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetImageInfoResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.info) {
            message.info = DatasetImageInfoWireFormat3.fromJson(wireFormat.info);
        }
        return message;
    }
};
export var GetDatasetLimitsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetMetadataRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetsByIdRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var GetDatasetSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetSuggestionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatasetSuggestionsResponse = {
    suggestions: []
};
export var GetDatasetSuggestionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetSuggestionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.suggestions) {
            message.suggestions = wireFormat.suggestions.map(function(i) {
                return SuggestionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetDatasetUploaderConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDatasetUpvotesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatasetUpvotesResponse = {
    voteCount: 0,
    medalVoteCount: 0,
    upVoters: []
};
export var GetDatasetUpvotesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetUpvotesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.upVoters) {
            message.upVoters = wireFormat.upVoters.map(function(i) {
                return KaggleSdkUsersUserWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetDatasetUsabilityRatingRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDatasetUsabilityRatingResponse = {};
export var GetDatasetUsabilityRatingResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDatasetUsabilityRatingResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rating) {
            message.rating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.rating);
        }
        return message;
    }
};
export var GetDataViewExternalRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.verificationInfo) {
            wireFormat.verificationInfo = KaggleSdkDatasetsDatabundlesDatabundleVerificationInfoWireFormat3.toJson(message.verificationInfo);
        }
        if (message === null || message === void 0 ? void 0 : message.tableQuery) {
            wireFormat.tableQuery = KaggleSdkDatasetsDataViewerTableQueryWireFormat3.toJson(message.tableQuery);
        }
        return wireFormat;
    }
};
export var GetDeletedDatasetInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDeletedDatasetInfoResponse = {
    currentDatasetVersionId: 0
};
export var GetDeletedDatasetInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDeletedDatasetInfoResponse, wireFormat);
        return message;
    }
};
export var GetDeletedDoiDatasetVersionInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDeletedDoiDatasetVersionInfoResponse = {
    datasetId: 0
};
export var GetDeletedDoiDatasetVersionInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDeletedDoiDatasetVersionInfoResponse, wireFormat);
        return message;
    }
};
export var GetGithubRepositoryInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetGithubRepositoryInfoResponse = {
    repositoryContents: []
};
export var GetGithubRepositoryInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetGithubRepositoryInfoResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.repositoryContents) {
            message.repositoryContents = wireFormat.repositoryContents.map(function(i) {
                return GithubRepositoryContentWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetKernelOutputDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetKernelOutputDataViewExternalRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.tableQuery) {
            wireFormat.tableQuery = KaggleSdkDatasetsDataViewerTableQueryWireFormat3.toJson(message.tableQuery);
        }
        return wireFormat;
    }
};
export var GetLandingPageTopicsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetLandingPageTopicsResponse = {
    topics: []
};
export var GetLandingPageTopicsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetLandingPageTopicsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topics) {
            message.topics = wireFormat.topics.map(function(i) {
                return DatasetTopicContentWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetProfileDatasetStatsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetProfileDatasetStatsResponse = {
    datasetsCount: 0,
    upvotesCount: 0,
    tasksCount: 0,
    acceptedSubmissionsCount: 0
};
export var GetProfileDatasetStatsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetProfileDatasetStatsResponse, wireFormat);
        return message;
    }
};
export var GetRecentlyViewedDatasetsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetRemoteUrlFileInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetTopicalDatasetsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.topicType) {
            wireFormat.topicType = DatasetTopicEnumWireFormat3.toJson(message.topicType);
        }
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = DatasetSortBy.EnumWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.initialResponseUpdateTime) {
            wireFormat.initialResponseUpdateTime = message.initialResponseUpdateTime.toISOString();
        }
        return wireFormat;
    }
};
var defaultGetTopicalDatasetsResponse = {
    datasets: [],
    hasMore: false
};
export var GetTopicalDatasetsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTopicalDatasetsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasets) {
            message.datasets = wireFormat.datasets.map(function(i) {
                return DatasetListItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.initialResponseUpdateTime) {
            message.initialResponseUpdateTime = new Date(wireFormat.initialResponseUpdateTime);
        }
        return message;
    }
};
export var GetUserLicenseAgreementStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserLicenseAgreementStatusResponse = {};
export var GetUserLicenseAgreementStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserLicenseAgreementStatusResponse, wireFormat);
        if (wireFormat) {
            message.status = UserLicenseAgreementStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updateTime) {
            message.updateTime = new Date(wireFormat.updateTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.consentTime) {
            message.consentTime = new Date(wireFormat.consentTime);
        }
        return message;
    }
};
var defaultGithubRepositoryContent = {
    name: "",
    repositoryPath: "",
    size: 0,
    children: []
};
export var GithubRepositoryContentWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGithubRepositoryContent, wireFormat);
        if (wireFormat) {
            message.type = GithubRepositoryContentTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.size) {
            message.size = parseInt(wireFormat.size);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return GithubRepositoryContentWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultKernelOutputDatasetReference = {
    datasetId: 0,
    currentDatasetVersionId: 0,
    title: "",
    isPrivate: false,
    slug: ""
};
export var KernelOutputDatasetReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelOutputDatasetReference, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.license) {
            message.license = LicenseOptionWireFormat3.fromJson(wireFormat.license);
        }
        return message;
    }
};
var defaultKernelOutputKernelReference = {
    kernelId: 0,
    isPrivate: false,
    outputFiles: []
};
export var KernelOutputKernelReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelOutputKernelReference, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
            message.owner = OwnerDtoWireFormat3.fromJson(wireFormat.owner);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFiles) {
            message.outputFiles = wireFormat.outputFiles.map(function(i) {
                return KaggleSdkKernelsKernelSessionOutputFileWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateOutputToDatasetEnabled) {
            message.dateOutputToDatasetEnabled = new Date(wireFormat.dateOutputToDatasetEnabled);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.owner) {
            wireFormat.owner = OwnerDtoWireFormat3.toJson(message.owner);
        }
        if (message === null || message === void 0 ? void 0 : message.outputFiles) {
            wireFormat.outputFiles = message.outputFiles.map(function(i) {
                return KaggleSdkKernelsKernelSessionOutputFileWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.dateOutputToDatasetEnabled) {
            wireFormat.dateOutputToDatasetEnabled = message.dateOutputToDatasetEnabled.toISOString();
        }
        return wireFormat;
    }
};
var defaultKernelTaskSubmissionInfo = {
    isAcceptedSolution: false
};
export var KernelTaskSubmissionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelTaskSubmissionInfo, wireFormat);
        return message;
    }
};
var defaultLegacyExistingFileInfo = {
    databundleVersionObjectId: 0,
    blobFileId: 0
};
export var LegacyExistingFileInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyExistingFileInfo, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultLicense = {
    id: 0,
    name: ""
};
export var LicenseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLicense, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.agreementStatus) != undefined) {
            message.agreementStatus = UserLicenseAgreementStatusWireFormat3.fromJson(wireFormat.agreementStatus);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.consentTime) {
            message.consentTime = new Date(wireFormat.consentTime);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.agreementStatus) {
            wireFormat.agreementStatus = UserLicenseAgreementStatusWireFormat3.toJson(message.agreementStatus);
        }
        if (message === null || message === void 0 ? void 0 : message.consentTime) {
            wireFormat.consentTime = message.consentTime.toISOString();
        }
        return wireFormat;
    }
};
var defaultLicenseGroupDto = {
    id: 0,
    licenses: []
};
export var LicenseGroupDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLicenseGroupDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.licenses) {
            message.licenses = wireFormat.licenses.map(function(i) {
                return LicenseOptionWireFormat3.fromJson(i);
            });
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.licenses) {
            wireFormat.licenses = message.licenses.map(function(i) {
                return LicenseOptionWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultLicenseOption = {
    id: 0,
    name: "",
    description: "",
    commercialUse: false
};
export var LicenseOptionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLicenseOption, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultOwner = {
    id: 0,
    imageUrl: "",
    organization: false,
    maxFileSizeBytes: 0,
    name: "",
    organizationMemberCount: 0,
    profileUrl: "",
    slug: ""
};
export var OwnerWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOwner, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxFileSizeBytes) {
            message.maxFileSizeBytes = parseInt(wireFormat.maxFileSizeBytes);
        }
        if (wireFormat) {
            message.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.userTier);
        }
        return message;
    }
};
var defaultOwnerDto = {
    id: 0,
    isOrganization: false,
    name: "",
    slug: ""
};
export var OwnerDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultOwnerDto, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxFileSizeBytes) {
            message.maxFileSizeBytes = parseInt(wireFormat.maxFileSizeBytes);
        }
        if (wireFormat) {
            message.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.userTier);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.maxFileSizeBytes) {
            wireFormat.maxFileSizeBytes = message.maxFileSizeBytes.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.userTier) {
            wireFormat.userTier = KaggleSdkUsersUserAchievementTierWireFormat3.toJson(message.userTier);
        }
        return wireFormat;
    }
};
export var RecreateDatasetArchiveRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultRecreateDatasetArchiveResponse = {
    databundleVersionId: 0,
    message: ""
};
export var RecreateDatasetArchiveResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRecreateDatasetArchiveResponse, wireFormat);
        return message;
    }
};
export var RefreshRemoteDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settings) {
            wireFormat.settings = DataCreationSettingsWireFormat3.toJson(message.settings);
        }
        return wireFormat;
    }
};
var defaultRemoteUrlUploadFile = {
    contentLength: 0
};
export var RemoteUrlUploadFileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRemoteUrlUploadFile, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        return message;
    }
};
export var SearchDatasetsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = DatasetSelectionGroup.EnumWireFormat3.toJson(message.group);
        }
        if (message === null || message === void 0 ? void 0 : message.size) {
            wireFormat.size = DatasetSizeGroup.EnumWireFormat3.toJson(message.size);
        }
        if (message === null || message === void 0 ? void 0 : message.fileType) {
            wireFormat.fileType = DatasetFileTypeGroup.EnumWireFormat3.toJson(message.fileType);
        }
        if (message === null || message === void 0 ? void 0 : message.license) {
            wireFormat.license = DatasetLicenseGroup.EnumWireFormat3.toJson(message.license);
        }
        if (message === null || message === void 0 ? void 0 : message.viewed) {
            wireFormat.viewed = DatasetViewedGroup.EnumWireFormat3.toJson(message.viewed);
        }
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = DatasetSortBy.EnumWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.minSize) {
            wireFormat.minSize = message.minSize.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.maxSize) {
            wireFormat.maxSize = message.maxSize.toString();
        }
        if ((message === null || message === void 0 ? void 0 : message.minUsabilityRating) != undefined && (message === null || message === void 0 ? void 0 : message.minUsabilityRating) != 0) {
            wireFormat.minUsabilityRating = Number.isFinite(message.minUsabilityRating) ? message.minUsabilityRating : Number(message.minUsabilityRating).toString();
        }
        if (message === null || message === void 0 ? void 0 : message.topicalDataset) {
            wireFormat.topicalDataset = TopicalDatasetWireFormat3.toJson(message.topicalDataset);
        }
        return wireFormat;
    }
};
var defaultSearchDatasetsResponse = {
    hasMore: false
};
export var SearchDatasetsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchDatasetsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.datasetList) {
            message.datasetList = DatasetListWireFormat3.fromJson(wireFormat.datasetList);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topicalDataset) {
            message.topicalDataset = TopicalDatasetWireFormat3.fromJson(wireFormat.topicalDataset);
        }
        return message;
    }
};
export var SetDatabundleVersionNotesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SetDatasetCollaboratorListRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.collaboratorList) {
            wireFormat.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaboratorList);
        }
        return wireFormat;
    }
};
export var SetDatasetSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settings) {
            wireFormat.settings = DatasetSettingsWireFormat3.toJson(message.settings);
        }
        return wireFormat;
    }
};
var defaultSettingsLicense = {};
export var SettingsLicenseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSettingsLicense, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
export var SoftDeleteDatasetsForOrgRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SoftDeleteDatasetsForUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultStorageLocation = {};
export var StorageLocationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultStorageLocation, wireFormat);
        return message;
    }
};
var defaultSuggestion = {
    entityId: 0
};
export var SuggestionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSuggestion, wireFormat);
        if (wireFormat) {
            message.entityType = SuggestionTypeWireFormat3.fromJson(wireFormat.entityType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.owner) {
            message.owner = OwnerDtoWireFormat3.fromJson(wireFormat.owner);
        }
        return message;
    }
};
var defaultTopicalDataset = {
    isPopular: false,
    isTrending: false
};
export var TopicalDatasetWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTopicalDataset, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topicUpdateTime) {
            message.topicUpdateTime = new Date(wireFormat.topicUpdateTime);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.topicUpdateTime) {
            wireFormat.topicUpdateTime = message.topicUpdateTime.toISOString();
        }
        return wireFormat;
    }
};
export var UpdateDatasetCollaboratorsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.collaborators) {
            wireFormat.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaborators);
        }
        return wireFormat;
    }
};
export var UpdateDatasetFeedbacksRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.updateType) {
            wireFormat.updateType = UpdateFeedbackTypeWireFormat3.toJson(message.updateType);
        }
        return wireFormat;
    }
};
export var UpdateDatasetGeneralRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.owner) {
            wireFormat.owner = OwnerDtoWireFormat3.toJson(message.owner);
        }
        if (message === null || message === void 0 ? void 0 : message.diffType) {
            wireFormat.diffType = DatabundleDiffTypeWireFormat3.toJson(message.diffType);
        }
        if (message === null || message === void 0 ? void 0 : message.updateFrequency) {
            wireFormat.updateFrequency = RemoteUrlUpdateFrequencyWireFormat3.toJson(message.updateFrequency);
        }
        if (message === null || message === void 0 ? void 0 : message.updateMask) {
            var _paths;
            wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultUpdateDatasetGeneralResponse = {};
export var UpdateDatasetGeneralResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateDatasetGeneralResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
            message.usabilityRating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
        }
        return message;
    }
};
export var UpdateDatasetImagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.image) {
            wireFormat.image = KaggleSdkCommonCroppedImageUploadWireFormat3.toJson(message.image);
        }
        return wireFormat;
    }
};
var defaultUpdateDatasetImagesResponse = {
    cardImageUrl: "",
    coverImageUrl: "",
    thumbnailImageUrl: "",
    originalImageUrl: ""
};
export var UpdateDatasetImagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateDatasetImagesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usabilityRating) {
            message.usabilityRating = DatasetUsabilityRatingWireFormat3.fromJson(wireFormat.usabilityRating);
        }
        return message;
    }
};
export var UpdateDatasetMetadataRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dataCoverageAttribute) {
            wireFormat.dataCoverageAttribute = DataCoverageAttributeWireFormat3.toJson(message.dataCoverageAttribute);
        }
        if (message === null || message === void 0 ? void 0 : message.datasetVersionAuthors) {
            wireFormat.datasetVersionAuthors = message.datasetVersionAuthors.map(function(i) {
                return DatasetVersionAuthorWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.updateMask) {
            var _paths;
            wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var UpdateDatasetPrivacyRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.maintainerOrganization) {
            wireFormat.maintainerOrganization = OwnerDtoWireFormat3.toJson(message.maintainerOrganization);
        }
        return wireFormat;
    }
};
var defaultUpdateDatasetResponse = {};
export var UpdateDatasetResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateDatasetResponse, wireFormat);
        return message;
    }
};
export var UploadDirectoryInfoWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.directories) {
            wireFormat.directories = message.directories.map(function(i) {
                return UploadDirectoryInfoWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.files) {
            wireFormat.files = message.files.map(function(i) {
                return UploadFileInfoWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var UploadFileInfoWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UploadKernelOutputInfoWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUserRole = {
    username: ""
};
export var UserRoleWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUserRole, wireFormat);
        if (wireFormat) {
            message.role = KaggleSdkUsersCollaboratorTypeWireFormat3.fromJson(wireFormat.role);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.role) {
            wireFormat.role = KaggleSdkUsersCollaboratorTypeWireFormat3.toJson(message.role);
        }
        return wireFormat;
    }
};
export var ValidateGcsBucketRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultValidateGcsBucketResponse = {};
export var ValidateGcsBucketResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultValidateGcsBucketResponse, wireFormat);
        if (wireFormat) {
            message.validationResult = GcsBucketValidationWireFormat3.fromJson(wireFormat.validationResult);
        }
        return message;
    }
};
export var VoteOnDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.voteType) {
            wireFormat.voteType = KaggleSdkCommonVoteTypeWireFormat3.toJson(message.voteType);
        }
        return wireFormat;
    }
};
export var ActivityPageStatus;
(function(ActivityPageStatus) {
    ActivityPageStatus["NOT_RELEVANT"] = "notRelevant";
    ActivityPageStatus["NO_SUMMARY_GENERATED"] = "noSummaryGenerated";
    ActivityPageStatus["HAS_SUMMARY"] = "hasSummary";
})(ActivityPageStatus || (ActivityPageStatus = {}));
export var ActivityPageStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NOT_RELEVANT":
            default:
                return ActivityPageStatus.NOT_RELEVANT;
            case "NO_SUMMARY_GENERATED":
                return ActivityPageStatus.NO_SUMMARY_GENERATED;
            case "HAS_SUMMARY":
                return ActivityPageStatus.HAS_SUMMARY;
        }
    }
};
export var CreationStatus;
(function(CreationStatus) {
    CreationStatus["OK"] = "ok";
    CreationStatus["ERROR"] = "error";
})(CreationStatus || (CreationStatus = {}));
export var CreationStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "CREATION_STATUS_OK":
            default:
                return CreationStatus.OK;
            case "CREATION_STATUS_ERROR":
                return CreationStatus.ERROR;
        }
    }
};
export var DatabundleDiffType;
(function(DatabundleDiffType) {
    DatabundleDiffType["REALTIME"] = "realtime";
    DatabundleDiffType["UNVERSIONED"] = "unversioned";
    DatabundleDiffType["VERSIONED"] = "versioned";
})(DatabundleDiffType || (DatabundleDiffType = {}));
export var DatabundleDiffTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "REALTIME":
            default:
                return DatabundleDiffType.REALTIME;
            case "UNVERSIONED":
                return DatabundleDiffType.UNVERSIONED;
            case "VERSIONED":
                return DatabundleDiffType.VERSIONED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DatabundleDiffType.REALTIME:
            case 0:
            default:
                return "REALTIME";
            case DatabundleDiffType.UNVERSIONED:
            case 1:
                return "UNVERSIONED";
            case DatabundleDiffType.VERSIONED:
            case 2:
                return "VERSIONED";
        }
    }
};
export var DatabundleStatus;
(function(DatabundleStatus) {
    DatabundleStatus["CREATED"] = "created";
    DatabundleStatus["PROCESSING"] = "processing";
    DatabundleStatus["ERROR"] = "error";
    DatabundleStatus["READY"] = "ready";
})(DatabundleStatus || (DatabundleStatus = {}));
export var DatabundleStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATABUNDLE_STATUS_CREATED":
            default:
                return DatabundleStatus.CREATED;
            case "DATABUNDLE_STATUS_PROCESSING":
                return DatabundleStatus.PROCESSING;
            case "DATABUNDLE_STATUS_ERROR":
                return DatabundleStatus.ERROR;
            case "DATABUNDLE_STATUS_READY":
                return DatabundleStatus.READY;
        }
    }
};
export var DatabundleType;
(function(DatabundleType) {
    DatabundleType["UNSPECIFIED"] = "unspecified";
    DatabundleType["GENERAL"] = "general";
    DatabundleType["DATASET"] = "dataset";
    DatabundleType["COMPETITION"] = "competition";
    DatabundleType["NOTEBOOK"] = "notebook";
    DatabundleType["COMPETITION_RERUN"] = "competitionRerun";
    DatabundleType["MODEL"] = "model";
})(DatabundleType || (DatabundleType = {}));
export var DatabundleTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATABUNDLE_TYPE_UNSPECIFIED":
            default:
                return DatabundleType.UNSPECIFIED;
            case "DATABUNDLE_TYPE_GENERAL":
                return DatabundleType.GENERAL;
            case "DATABUNDLE_TYPE_DATASET":
                return DatabundleType.DATASET;
            case "DATABUNDLE_TYPE_COMPETITION":
                return DatabundleType.COMPETITION;
            case "DATABUNDLE_TYPE_NOTEBOOK":
                return DatabundleType.NOTEBOOK;
            case "DATABUNDLE_TYPE_COMPETITION_RERUN":
                return DatabundleType.COMPETITION_RERUN;
            case "DATABUNDLE_TYPE_MODEL":
                return DatabundleType.MODEL;
        }
    }
};
export var DatabundleVersionStatus;
(function(DatabundleVersionStatus) {
    DatabundleVersionStatus["NOT_YET_PERSISTED"] = "notYetPersisted";
    DatabundleVersionStatus["BLOBS_RECEIVED"] = "blobsReceived";
    DatabundleVersionStatus["BLOBS_DECOMPRESSED"] = "blobsDecompressed";
    DatabundleVersionStatus["BLOBS_COPIED_TO_SDS"] = "blobsCopiedToSds";
    DatabundleVersionStatus["INDIVIDUAL_BLOBS_COMPRESSED"] = "individualBlobsCompressed";
    DatabundleVersionStatus["READY"] = "ready";
    DatabundleVersionStatus["FAILED"] = "failed";
    DatabundleVersionStatus["DELETED"] = "deleted";
    DatabundleVersionStatus["REPROCESSING"] = "reprocessing";
})(DatabundleVersionStatus || (DatabundleVersionStatus = {}));
export var DatabundleVersionStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NOT_YET_PERSISTED":
            default:
                return DatabundleVersionStatus.NOT_YET_PERSISTED;
            case "BLOBS_RECEIVED":
                return DatabundleVersionStatus.BLOBS_RECEIVED;
            case "BLOBS_DECOMPRESSED":
                return DatabundleVersionStatus.BLOBS_DECOMPRESSED;
            case "BLOBS_COPIED_TO_SDS":
                return DatabundleVersionStatus.BLOBS_COPIED_TO_SDS;
            case "INDIVIDUAL_BLOBS_COMPRESSED":
                return DatabundleVersionStatus.INDIVIDUAL_BLOBS_COMPRESSED;
            case "READY":
                return DatabundleVersionStatus.READY;
            case "FAILED":
                return DatabundleVersionStatus.FAILED;
            case "DELETED":
                return DatabundleVersionStatus.DELETED;
            case "REPROCESSING":
                return DatabundleVersionStatus.REPROCESSING;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DatabundleVersionStatus.NOT_YET_PERSISTED:
            case 0:
            default:
                return "NOT_YET_PERSISTED";
            case DatabundleVersionStatus.BLOBS_RECEIVED:
            case 1:
                return "BLOBS_RECEIVED";
            case DatabundleVersionStatus.BLOBS_DECOMPRESSED:
            case 2:
                return "BLOBS_DECOMPRESSED";
            case DatabundleVersionStatus.BLOBS_COPIED_TO_SDS:
            case 3:
                return "BLOBS_COPIED_TO_SDS";
            case DatabundleVersionStatus.INDIVIDUAL_BLOBS_COMPRESSED:
            case 4:
                return "INDIVIDUAL_BLOBS_COMPRESSED";
            case DatabundleVersionStatus.READY:
            case 5:
                return "READY";
            case DatabundleVersionStatus.FAILED:
            case 6:
                return "FAILED";
            case DatabundleVersionStatus.DELETED:
            case 7:
                return "DELETED";
            case DatabundleVersionStatus.REPROCESSING:
            case 8:
                return "REPROCESSING";
        }
    }
};
export var DatabundleVersionType;
(function(DatabundleVersionType) {
    DatabundleVersionType["UNSPECIFIED"] = "unspecified";
    DatabundleVersionType["FILESET"] = "fileset";
    DatabundleVersionType["BIG_QUERY"] = "bigQuery";
    DatabundleVersionType["REMOTE_URL_FILE_SET"] = "remoteUrlFileSet";
    DatabundleVersionType["REMOTE_GIT_REPOSITORY_FILE_SET"] = "remoteGitRepositoryFileSet";
    DatabundleVersionType["KERNEL_OUTPUT_FILE_SET"] = "kernelOutputFileSet";
    DatabundleVersionType["GCS_FILE_SET"] = "gcsFileSet";
})(DatabundleVersionType || (DatabundleVersionType = {}));
export var DatabundleVersionTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATABUNDLE_VERSION_TYPE_UNSPECIFIED":
            default:
                return DatabundleVersionType.UNSPECIFIED;
            case "FILESET":
                return DatabundleVersionType.FILESET;
            case "BIG_QUERY":
                return DatabundleVersionType.BIG_QUERY;
            case "REMOTE_URL_FILE_SET":
                return DatabundleVersionType.REMOTE_URL_FILE_SET;
            case "REMOTE_GIT_REPOSITORY_FILE_SET":
                return DatabundleVersionType.REMOTE_GIT_REPOSITORY_FILE_SET;
            case "KERNEL_OUTPUT_FILE_SET":
                return DatabundleVersionType.KERNEL_OUTPUT_FILE_SET;
            case "GCS_FILE_SET":
                return DatabundleVersionType.GCS_FILE_SET;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DatabundleVersionType.UNSPECIFIED:
            case 0:
            default:
                return "DATABUNDLE_VERSION_TYPE_UNSPECIFIED";
            case DatabundleVersionType.FILESET:
            case 1:
                return "FILESET";
            case DatabundleVersionType.BIG_QUERY:
            case 2:
                return "BIG_QUERY";
            case DatabundleVersionType.REMOTE_URL_FILE_SET:
            case 3:
                return "REMOTE_URL_FILE_SET";
            case DatabundleVersionType.REMOTE_GIT_REPOSITORY_FILE_SET:
            case 4:
                return "REMOTE_GIT_REPOSITORY_FILE_SET";
            case DatabundleVersionType.KERNEL_OUTPUT_FILE_SET:
            case 5:
                return "KERNEL_OUTPUT_FILE_SET";
            case DatabundleVersionType.GCS_FILE_SET:
            case 6:
                return "GCS_FILE_SET";
        }
    }
};
export var DatasetActivityType;
(function(DatasetActivityType) {
    DatasetActivityType["SCRIPT"] = "script";
    DatasetActivityType["SCRIPT_FORK"] = "scriptFork";
    DatasetActivityType["SCRIPT_RUN"] = "scriptRun";
    DatasetActivityType["DATASET"] = "dataset";
    DatasetActivityType["DATASET_VERSION"] = "datasetVersion";
    DatasetActivityType["COMMENT"] = "comment";
    DatasetActivityType["SCRIPT_COMMENT"] = "scriptComment";
    DatasetActivityType["TOPIC"] = "topic";
})(DatasetActivityType || (DatasetActivityType = {}));
export var DatasetsActivityTypeEnum;
(function(DatasetsActivityTypeEnum) {
    DatasetsActivityTypeEnum["UNSPECIFIED"] = "unspecified";
    DatasetsActivityTypeEnum["CREATE"] = "create";
    DatasetsActivityTypeEnum["NEW_VERSION"] = "newVersion";
    DatasetsActivityTypeEnum["FEATURE"] = "feature";
    DatasetsActivityTypeEnum["SUPER_FEATURE"] = "superFeature";
    DatasetsActivityTypeEnum["UN_FEATURE"] = "unFeature";
    DatasetsActivityTypeEnum["UN_SUPER_FEATURE"] = "unSuperFeature";
    DatasetsActivityTypeEnum["REMOVE"] = "remove";
    DatasetsActivityTypeEnum["REMOVE_VERSION"] = "removeVersion";
    DatasetsActivityTypeEnum["PUBLISH"] = "publish";
    DatasetsActivityTypeEnum["UN_PUBLISH"] = "unPublish";
    DatasetsActivityTypeEnum["MAKE_PUBLIC"] = "makePublic";
    DatasetsActivityTypeEnum["MAKE_PRIVATE"] = "makePrivate";
    DatasetsActivityTypeEnum["INTRA_VERSION_SCHEMA_UPDATE"] = "intraVersionSchemaUpdate";
})(DatasetsActivityTypeEnum || (DatasetsActivityTypeEnum = {}));
export var DatasetsActivityTypeEnumWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATASETS_ACTIVITY_TYPE_ENUM_UNSPECIFIED":
            default:
                return DatasetsActivityTypeEnum.UNSPECIFIED;
            case "CREATE":
                return DatasetsActivityTypeEnum.CREATE;
            case "NEW_VERSION":
                return DatasetsActivityTypeEnum.NEW_VERSION;
            case "FEATURE":
                return DatasetsActivityTypeEnum.FEATURE;
            case "SUPER_FEATURE":
                return DatasetsActivityTypeEnum.SUPER_FEATURE;
            case "UN_FEATURE":
                return DatasetsActivityTypeEnum.UN_FEATURE;
            case "UN_SUPER_FEATURE":
                return DatasetsActivityTypeEnum.UN_SUPER_FEATURE;
            case "REMOVE":
                return DatasetsActivityTypeEnum.REMOVE;
            case "REMOVE_VERSION":
                return DatasetsActivityTypeEnum.REMOVE_VERSION;
            case "PUBLISH":
                return DatasetsActivityTypeEnum.PUBLISH;
            case "UN_PUBLISH":
                return DatasetsActivityTypeEnum.UN_PUBLISH;
            case "MAKE_PUBLIC":
                return DatasetsActivityTypeEnum.MAKE_PUBLIC;
            case "MAKE_PRIVATE":
                return DatasetsActivityTypeEnum.MAKE_PRIVATE;
            case "INTRA_VERSION_SCHEMA_UPDATE":
                return DatasetsActivityTypeEnum.INTRA_VERSION_SCHEMA_UPDATE;
        }
    }
};
export var DatasetSchemaDiffAction;
(function(DatasetSchemaDiffAction) {
    DatasetSchemaDiffAction["ADD"] = "add";
    DatasetSchemaDiffAction["DELETE"] = "delete";
    DatasetSchemaDiffAction["MODIFY_DESCRIPTION"] = "modifyDescription";
    DatasetSchemaDiffAction["MODIFY_TYPE"] = "modifyType";
    DatasetSchemaDiffAction["ROW_COUNT_CHANGE"] = "rowCountChange";
    DatasetSchemaDiffAction["SIZE_CHANGE"] = "sizeChange";
})(DatasetSchemaDiffAction || (DatasetSchemaDiffAction = {}));
export var DatasetSchemaDiffActionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATASET_SCHEMA_DIFF_ACTION_ADD":
            default:
                return DatasetSchemaDiffAction.ADD;
            case "DATASET_SCHEMA_DIFF_ACTION_DELETE":
                return DatasetSchemaDiffAction.DELETE;
            case "DATASET_SCHEMA_DIFF_ACTION_MODIFY_DESCRIPTION":
                return DatasetSchemaDiffAction.MODIFY_DESCRIPTION;
            case "DATASET_SCHEMA_DIFF_ACTION_MODIFY_TYPE":
                return DatasetSchemaDiffAction.MODIFY_TYPE;
            case "DATASET_SCHEMA_DIFF_ACTION_ROW_COUNT_CHANGE":
                return DatasetSchemaDiffAction.ROW_COUNT_CHANGE;
            case "DATASET_SCHEMA_DIFF_ACTION_SIZE_CHANGE":
                return DatasetSchemaDiffAction.SIZE_CHANGE;
        }
    }
};
export var DatasetSchemaDiffContainerLevel;
(function(DatasetSchemaDiffContainerLevel) {
    DatasetSchemaDiffContainerLevel["UNKNOWN"] = "unknown";
    DatasetSchemaDiffContainerLevel["DATASET"] = "dataset";
    DatasetSchemaDiffContainerLevel["FILE"] = "file";
    DatasetSchemaDiffContainerLevel["TABLE"] = "table";
    DatasetSchemaDiffContainerLevel["COLUMN"] = "column";
})(DatasetSchemaDiffContainerLevel || (DatasetSchemaDiffContainerLevel = {}));
export var DatasetSchemaDiffContainerLevelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_UNKNOWN":
            default:
                return DatasetSchemaDiffContainerLevel.UNKNOWN;
            case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_DATASET":
                return DatasetSchemaDiffContainerLevel.DATASET;
            case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_FILE":
                return DatasetSchemaDiffContainerLevel.FILE;
            case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_TABLE":
                return DatasetSchemaDiffContainerLevel.TABLE;
            case "DATASET_SCHEMA_DIFF_CONTAINER_LEVEL_COLUMN":
                return DatasetSchemaDiffContainerLevel.COLUMN;
        }
    }
};
export var DatasetTab;
(function(DatasetTab) {
    DatasetTab["DATA"] = "data";
    DatasetTab["DATA_OLD"] = "dataOld";
    DatasetTab["KERNELS"] = "kernels";
    DatasetTab["NOTEBOOKS"] = "notebooks";
    DatasetTab["CODE"] = "code";
    DatasetTab["DISCUSSION"] = "discussion";
    DatasetTab["ACTIVITY"] = "activity";
    DatasetTab["METADATA"] = "metadata";
    DatasetTab["SETTINGS"] = "settings";
    DatasetTab["TASKS"] = "tasks";
    DatasetTab["HOME"] = "home";
    DatasetTab["ADMIN"] = "admin";
})(DatasetTab || (DatasetTab = {}));
export var DatasetTabWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATA":
            default:
                return DatasetTab.DATA;
            case "DATA_OLD":
                return DatasetTab.DATA_OLD;
            case "KERNELS":
                return DatasetTab.KERNELS;
            case "NOTEBOOKS":
                return DatasetTab.NOTEBOOKS;
            case "CODE":
                return DatasetTab.CODE;
            case "DISCUSSION":
                return DatasetTab.DISCUSSION;
            case "ACTIVITY":
                return DatasetTab.ACTIVITY;
            case "METADATA":
                return DatasetTab.METADATA;
            case "SETTINGS":
                return DatasetTab.SETTINGS;
            case "TASKS":
                return DatasetTab.TASKS;
            case "HOME":
                return DatasetTab.HOME;
            case "ADMIN":
                return DatasetTab.ADMIN;
        }
    }
};
export var DatasetTopicEnum;
(function(DatasetTopicEnum) {
    DatasetTopicEnum["UNSPECIFIED"] = "unspecified";
    DatasetTopicEnum["POPULAR_DATASET"] = "popularDataset";
    DatasetTopicEnum["TRENDING_DATASET"] = "trendingDataset";
    DatasetTopicEnum["TRENDING_TASK"] = "trendingTask";
    DatasetTopicEnum["RECENTLY_VIEWED"] = "recentlyViewed";
    DatasetTopicEnum["BUSINESS_DATASET"] = "businessDataset";
    DatasetTopicEnum["ARTS_AND_ENTERTAINMENT_DATASET"] = "artsAndEntertainmentDataset";
    DatasetTopicEnum["EDUCATION_DATASET"] = "educationDataset";
    DatasetTopicEnum["HEALTH_DATASET"] = "healthDataset";
    DatasetTopicEnum["IMAGE_DATASET"] = "imageDataset";
    DatasetTopicEnum["ECONOMICS_DATASET"] = "economicsDataset";
    DatasetTopicEnum["COVID_DATASET"] = "covidDataset";
    DatasetTopicEnum["CLASSIFICATION_DATASET"] = "classificationDataset";
    DatasetTopicEnum["NLP_DATASET"] = "nlpDataset";
    DatasetTopicEnum["EARTH_AND_NATURE_DATASET"] = "earthAndNatureDataset";
    DatasetTopicEnum["COMPUTER_SCIENCE_DATASET"] = "computerScienceDataset";
    DatasetTopicEnum["CLOTHING_AND_ACCESSORIES_DATASET"] = "clothingAndAccessoriesDataset";
    DatasetTopicEnum["INTERNET_DATASET"] = "internetDataset";
    DatasetTopicEnum["ONLINE_COMMUNITIES_DATASET"] = "onlineCommunitiesDataset";
    DatasetTopicEnum["SOFTWARE_DATASET"] = "softwareDataset";
    DatasetTopicEnum["EXERCISE_DATASET"] = "exerciseDataset";
    DatasetTopicEnum["FOOD_DATASET"] = "foodDataset";
    DatasetTopicEnum["MOVIES_AND_TV_SHOWS_DATASET"] = "moviesAndTvShowsDataset";
    DatasetTopicEnum["NEWS_DATASET"] = "newsDataset";
    DatasetTopicEnum["PROGRAMMING_DATASET"] = "programmingDataset";
    DatasetTopicEnum["BIOLOGY_DATASET"] = "biologyDataset";
    DatasetTopicEnum["SOCIAL_SCIENCE_DATASET"] = "socialScienceDataset";
    DatasetTopicEnum["MUSIC_DATASET"] = "musicDataset";
    DatasetTopicEnum["FINANCE_DATASET"] = "financeDataset";
    DatasetTopicEnum["CANCER_DATASET"] = "cancerDataset";
    DatasetTopicEnum["AUTOMOBILES_AND_VEHICLES_DATASET"] = "automobilesAndVehiclesDataset";
    DatasetTopicEnum["RETAIL_AND_SHOPPING_DATASET"] = "retailAndShoppingDataset";
    DatasetTopicEnum["INVESTING_DATASET"] = "investingDataset";
    DatasetTopicEnum["SPORTS_DATASET"] = "sportsDataset";
    DatasetTopicEnum["STANDARDIZED_TESTING_DATASET"] = "standardizedTestingDataset";
    DatasetTopicEnum["TRANSPORTATION_DATASET"] = "transportationDataset";
    DatasetTopicEnum["UNIVERSITIES_AND_COLLEGES_DATASET"] = "universitiesAndCollegesDataset";
    DatasetTopicEnum["LAW_DATASET"] = "lawDataset";
    DatasetTopicEnum["GAMES_DATASET"] = "gamesDataset";
    DatasetTopicEnum["TRAVEL_DATASET"] = "travelDataset";
    DatasetTopicEnum["SOCIAL_NETWORKS_DATASET"] = "socialNetworksDataset";
    DatasetTopicEnum["SOCIAL_ISSUES_AND_ADVOCACY_DATASET"] = "socialIssuesAndAdvocacyDataset";
    DatasetTopicEnum["TEXT_DATASET"] = "textDataset";
})(DatasetTopicEnum || (DatasetTopicEnum = {}));
export var DatasetTopicEnumWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATASET_TOPIC_ENUM_UNSPECIFIED":
            default:
                return DatasetTopicEnum.UNSPECIFIED;
            case "POPULAR_DATASET":
                return DatasetTopicEnum.POPULAR_DATASET;
            case "TRENDING_DATASET":
                return DatasetTopicEnum.TRENDING_DATASET;
            case "TRENDING_TASK":
                return DatasetTopicEnum.TRENDING_TASK;
            case "RECENTLY_VIEWED":
                return DatasetTopicEnum.RECENTLY_VIEWED;
            case "BUSINESS_DATASET":
                return DatasetTopicEnum.BUSINESS_DATASET;
            case "ARTS_AND_ENTERTAINMENT_DATASET":
                return DatasetTopicEnum.ARTS_AND_ENTERTAINMENT_DATASET;
            case "EDUCATION_DATASET":
                return DatasetTopicEnum.EDUCATION_DATASET;
            case "HEALTH_DATASET":
                return DatasetTopicEnum.HEALTH_DATASET;
            case "IMAGE_DATASET":
                return DatasetTopicEnum.IMAGE_DATASET;
            case "ECONOMICS_DATASET":
                return DatasetTopicEnum.ECONOMICS_DATASET;
            case "COVID_DATASET":
                return DatasetTopicEnum.COVID_DATASET;
            case "CLASSIFICATION_DATASET":
                return DatasetTopicEnum.CLASSIFICATION_DATASET;
            case "NLP_DATASET":
                return DatasetTopicEnum.NLP_DATASET;
            case "EARTH_AND_NATURE_DATASET":
                return DatasetTopicEnum.EARTH_AND_NATURE_DATASET;
            case "COMPUTER_SCIENCE_DATASET":
                return DatasetTopicEnum.COMPUTER_SCIENCE_DATASET;
            case "CLOTHING_AND_ACCESSORIES_DATASET":
                return DatasetTopicEnum.CLOTHING_AND_ACCESSORIES_DATASET;
            case "INTERNET_DATASET":
                return DatasetTopicEnum.INTERNET_DATASET;
            case "ONLINE_COMMUNITIES_DATASET":
                return DatasetTopicEnum.ONLINE_COMMUNITIES_DATASET;
            case "SOFTWARE_DATASET":
                return DatasetTopicEnum.SOFTWARE_DATASET;
            case "EXERCISE_DATASET":
                return DatasetTopicEnum.EXERCISE_DATASET;
            case "FOOD_DATASET":
                return DatasetTopicEnum.FOOD_DATASET;
            case "MOVIES_AND_TV_SHOWS_DATASET":
                return DatasetTopicEnum.MOVIES_AND_TV_SHOWS_DATASET;
            case "NEWS_DATASET":
                return DatasetTopicEnum.NEWS_DATASET;
            case "PROGRAMMING_DATASET":
                return DatasetTopicEnum.PROGRAMMING_DATASET;
            case "BIOLOGY_DATASET":
                return DatasetTopicEnum.BIOLOGY_DATASET;
            case "SOCIAL_SCIENCE_DATASET":
                return DatasetTopicEnum.SOCIAL_SCIENCE_DATASET;
            case "MUSIC_DATASET":
                return DatasetTopicEnum.MUSIC_DATASET;
            case "FINANCE_DATASET":
                return DatasetTopicEnum.FINANCE_DATASET;
            case "CANCER_DATASET":
                return DatasetTopicEnum.CANCER_DATASET;
            case "AUTOMOBILES_AND_VEHICLES_DATASET":
                return DatasetTopicEnum.AUTOMOBILES_AND_VEHICLES_DATASET;
            case "RETAIL_AND_SHOPPING_DATASET":
                return DatasetTopicEnum.RETAIL_AND_SHOPPING_DATASET;
            case "INVESTING_DATASET":
                return DatasetTopicEnum.INVESTING_DATASET;
            case "SPORTS_DATASET":
                return DatasetTopicEnum.SPORTS_DATASET;
            case "STANDARDIZED_TESTING_DATASET":
                return DatasetTopicEnum.STANDARDIZED_TESTING_DATASET;
            case "TRANSPORTATION_DATASET":
                return DatasetTopicEnum.TRANSPORTATION_DATASET;
            case "UNIVERSITIES_AND_COLLEGES_DATASET":
                return DatasetTopicEnum.UNIVERSITIES_AND_COLLEGES_DATASET;
            case "LAW_DATASET":
                return DatasetTopicEnum.LAW_DATASET;
            case "GAMES_DATASET":
                return DatasetTopicEnum.GAMES_DATASET;
            case "TRAVEL_DATASET":
                return DatasetTopicEnum.TRAVEL_DATASET;
            case "SOCIAL_NETWORKS_DATASET":
                return DatasetTopicEnum.SOCIAL_NETWORKS_DATASET;
            case "SOCIAL_ISSUES_AND_ADVOCACY_DATASET":
                return DatasetTopicEnum.SOCIAL_ISSUES_AND_ADVOCACY_DATASET;
            case "TEXT_DATASET":
                return DatasetTopicEnum.TEXT_DATASET;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DatasetTopicEnum.UNSPECIFIED:
            case 0:
            default:
                return "DATASET_TOPIC_ENUM_UNSPECIFIED";
            case DatasetTopicEnum.POPULAR_DATASET:
            case 1:
                return "POPULAR_DATASET";
            case DatasetTopicEnum.TRENDING_DATASET:
            case 2:
                return "TRENDING_DATASET";
            case DatasetTopicEnum.TRENDING_TASK:
            case 3:
                return "TRENDING_TASK";
            case DatasetTopicEnum.RECENTLY_VIEWED:
            case 4:
                return "RECENTLY_VIEWED";
            case DatasetTopicEnum.BUSINESS_DATASET:
            case 11102:
                return "BUSINESS_DATASET";
            case DatasetTopicEnum.ARTS_AND_ENTERTAINMENT_DATASET:
            case 2200:
                return "ARTS_AND_ENTERTAINMENT_DATASET";
            case DatasetTopicEnum.EDUCATION_DATASET:
            case 11105:
                return "EDUCATION_DATASET";
            case DatasetTopicEnum.HEALTH_DATASET:
            case 11111:
                return "HEALTH_DATASET";
            case DatasetTopicEnum.IMAGE_DATASET:
            case 14102:
                return "IMAGE_DATASET";
            case DatasetTopicEnum.ECONOMICS_DATASET:
            case 11205:
                return "ECONOMICS_DATASET";
            case DatasetTopicEnum.COVID_DATASET:
            case 16575:
                return "COVID_DATASET";
            case DatasetTopicEnum.CLASSIFICATION_DATASET:
            case 13302:
                return "CLASSIFICATION_DATASET";
            case DatasetTopicEnum.NLP_DATASET:
            case 13204:
                return "NLP_DATASET";
            case DatasetTopicEnum.EARTH_AND_NATURE_DATASET:
            case 7000:
                return "EARTH_AND_NATURE_DATASET";
            case DatasetTopicEnum.COMPUTER_SCIENCE_DATASET:
            case 12107:
                return "COMPUTER_SCIENCE_DATASET";
            case DatasetTopicEnum.CLOTHING_AND_ACCESSORIES_DATASET:
            case 8301:
                return "CLOTHING_AND_ACCESSORIES_DATASET";
            case DatasetTopicEnum.INTERNET_DATASET:
            case 12116:
                return "INTERNET_DATASET";
            case DatasetTopicEnum.ONLINE_COMMUNITIES_DATASET:
            case 16489:
                return "ONLINE_COMMUNITIES_DATASET";
            case DatasetTopicEnum.SOFTWARE_DATASET:
            case 12127:
                return "SOFTWARE_DATASET";
            case DatasetTopicEnum.EXERCISE_DATASET:
            case 4130:
                return "EXERCISE_DATASET";
            case DatasetTopicEnum.FOOD_DATASET:
            case 16113:
                return "FOOD_DATASET";
            case DatasetTopicEnum.MOVIES_AND_TV_SHOWS_DATASET:
            case 2303:
                return "MOVIES_AND_TV_SHOWS_DATASET";
            case DatasetTopicEnum.NEWS_DATASET:
            case 16430:
                return "NEWS_DATASET";
            case DatasetTopicEnum.PROGRAMMING_DATASET:
            case 12125:
                return "PROGRAMMING_DATASET";
            case DatasetTopicEnum.BIOLOGY_DATASET:
            case 7100:
                return "BIOLOGY_DATASET";
            case DatasetTopicEnum.SOCIAL_SCIENCE_DATASET:
            case 11200:
                return "SOCIAL_SCIENCE_DATASET";
            case DatasetTopicEnum.MUSIC_DATASET:
            case 2304:
                return "MUSIC_DATASET";
            case DatasetTopicEnum.FINANCE_DATASET:
            case 11108:
                return "FINANCE_DATASET";
            case DatasetTopicEnum.CANCER_DATASET:
            case 16382:
                return "CANCER_DATASET";
            case DatasetTopicEnum.AUTOMOBILES_AND_VEHICLES_DATASET:
            case 12402:
                return "AUTOMOBILES_AND_VEHICLES_DATASET";
            case DatasetTopicEnum.RETAIL_AND_SHOPPING_DATASET:
            case 16281:
                return "RETAIL_AND_SHOPPING_DATASET";
            case DatasetTopicEnum.INVESTING_DATASET:
            case 16371:
                return "INVESTING_DATASET";
            case DatasetTopicEnum.SPORTS_DATASET:
            case 4141:
                return "SPORTS_DATASET";
            case DatasetTopicEnum.STANDARDIZED_TESTING_DATASET:
            case 16410:
                return "STANDARDIZED_TESTING_DATASET";
            case DatasetTopicEnum.TRANSPORTATION_DATASET:
            case 12400:
                return "TRANSPORTATION_DATASET";
            case DatasetTopicEnum.UNIVERSITIES_AND_COLLEGES_DATASET:
            case 1222:
                return "UNIVERSITIES_AND_COLLEGES_DATASET";
            case DatasetTopicEnum.LAW_DATASET:
            case 11115:
                return "LAW_DATASET";
            case DatasetTopicEnum.GAMES_DATASET:
            case 2500:
                return "GAMES_DATASET";
            case DatasetTopicEnum.TRAVEL_DATASET:
            case 16461:
                return "TRAVEL_DATASET";
            case DatasetTopicEnum.SOCIAL_NETWORKS_DATASET:
            case 16502:
                return "SOCIAL_NETWORKS_DATASET";
            case DatasetTopicEnum.SOCIAL_ISSUES_AND_ADVOCACY_DATASET:
            case 16453:
                return "SOCIAL_ISSUES_AND_ADVOCACY_DATASET";
            case DatasetTopicEnum.TEXT_DATASET:
            case 14104:
                return "TEXT_DATASET";
        }
    }
};
export var DuplicationReferenceType;
(function(DuplicationReferenceType) {
    DuplicationReferenceType["COMPETITION"] = "competition";
    DuplicationReferenceType["DATASET"] = "dataset";
})(DuplicationReferenceType || (DuplicationReferenceType = {}));
export var DuplicationReferenceTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DUPLICATION_REFERENCE_TYPE_COMPETITION":
            default:
                return DuplicationReferenceType.COMPETITION;
            case "DUPLICATION_REFERENCE_TYPE_DATASET":
                return DuplicationReferenceType.DATASET;
        }
    }
};
export var FeedbackState;
(function(FeedbackState) {
    FeedbackState["UNSPECIFIED"] = "unspecified";
    FeedbackState["VOTED"] = "voted";
    FeedbackState["NO_VOTE"] = "noVote";
})(FeedbackState || (FeedbackState = {}));
export var FeedbackStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "FEEDBACK_STATE_UNSPECIFIED":
            default:
                return FeedbackState.UNSPECIFIED;
            case "VOTED":
                return FeedbackState.VOTED;
            case "NO_VOTE":
                return FeedbackState.NO_VOTE;
        }
    }
};
export var FeedbackType;
(function(FeedbackType) {
    FeedbackType["UNSPECIFIED"] = "unspecified";
    FeedbackType["DATASET_USAGE"] = "datasetUsage";
    FeedbackType["DATASET_PROPERTIES"] = "datasetProperties";
})(FeedbackType || (FeedbackType = {}));
export var FeedbackTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "FEEDBACK_TYPE_UNSPECIFIED":
            default:
                return FeedbackType.UNSPECIFIED;
            case "DATASET_USAGE":
                return FeedbackType.DATASET_USAGE;
            case "DATASET_PROPERTIES":
                return FeedbackType.DATASET_PROPERTIES;
        }
    }
};
export var GcsBucketValidation;
(function(GcsBucketValidation) {
    GcsBucketValidation["UNDEFINED"] = "undefined";
    GcsBucketValidation["GCS_BUCKET_OK"] = "gcsBucketOk";
    GcsBucketValidation["GCS_BUCKET_EMPTY"] = "gcsBucketEmpty";
    GcsBucketValidation["GCS_BUCKET_PRIVATE"] = "gcsBucketPrivate";
    GcsBucketValidation["GCS_BUCKET_NOT_FOUND"] = "gcsBucketNotFound";
})(GcsBucketValidation || (GcsBucketValidation = {}));
export var GcsBucketValidationWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "GCS_BUCKET_VALIDATION_UNDEFINED":
            default:
                return GcsBucketValidation.UNDEFINED;
            case "GCS_BUCKET_OK":
                return GcsBucketValidation.GCS_BUCKET_OK;
            case "GCS_BUCKET_EMPTY":
                return GcsBucketValidation.GCS_BUCKET_EMPTY;
            case "GCS_BUCKET_PRIVATE":
                return GcsBucketValidation.GCS_BUCKET_PRIVATE;
            case "GCS_BUCKET_NOT_FOUND":
                return GcsBucketValidation.GCS_BUCKET_NOT_FOUND;
        }
    }
};
export var GithubRepositoryContentType;
(function(GithubRepositoryContentType) {
    GithubRepositoryContentType["FILE"] = "file";
    GithubRepositoryContentType["FOLDER"] = "folder";
})(GithubRepositoryContentType || (GithubRepositoryContentType = {}));
export var GithubRepositoryContentTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "GITHUB_REPOSITORY_CONTENT_TYPE_FILE":
            default:
                return GithubRepositoryContentType.FILE;
            case "GITHUB_REPOSITORY_CONTENT_TYPE_FOLDER":
                return GithubRepositoryContentType.FOLDER;
        }
    }
};
export var RemoteUrlUpdateFrequency;
(function(RemoteUrlUpdateFrequency) {
    RemoteUrlUpdateFrequency["DAILY"] = "daily";
    RemoteUrlUpdateFrequency["WEEKLY"] = "weekly";
    RemoteUrlUpdateFrequency["MONTHLY"] = "monthly";
    RemoteUrlUpdateFrequency["NEVER"] = "never";
    RemoteUrlUpdateFrequency["QUARTERLY"] = "quarterly";
    RemoteUrlUpdateFrequency["ANNUALLY"] = "annually";
    RemoteUrlUpdateFrequency["HOURLY"] = "hourly";
    RemoteUrlUpdateFrequency[// The value of UNSPECIFIED should be 0 but we can't change the value of DAILY
    // because it is serialized as a number in the database (see the Settings
    // column in the DatabundleVersions table).
    "UNSPECIFIED"] = "unspecified";
})(RemoteUrlUpdateFrequency || (RemoteUrlUpdateFrequency = {}));
export var RemoteUrlUpdateFrequencyWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DAILY":
            default:
                return RemoteUrlUpdateFrequency.DAILY;
            case "WEEKLY":
                return RemoteUrlUpdateFrequency.WEEKLY;
            case "MONTHLY":
                return RemoteUrlUpdateFrequency.MONTHLY;
            case "NEVER":
                return RemoteUrlUpdateFrequency.NEVER;
            case "QUARTERLY":
                return RemoteUrlUpdateFrequency.QUARTERLY;
            case "ANNUALLY":
                return RemoteUrlUpdateFrequency.ANNUALLY;
            case "HOURLY":
                return RemoteUrlUpdateFrequency.HOURLY;
            case "REMOTE_URL_UPDATE_FREQUENCY_UNSPECIFIED":
                return RemoteUrlUpdateFrequency.UNSPECIFIED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case RemoteUrlUpdateFrequency.DAILY:
            case 0:
            default:
                return "DAILY";
            case RemoteUrlUpdateFrequency.WEEKLY:
            case 1:
                return "WEEKLY";
            case RemoteUrlUpdateFrequency.MONTHLY:
            case 2:
                return "MONTHLY";
            case RemoteUrlUpdateFrequency.NEVER:
            case 3:
                return "NEVER";
            case RemoteUrlUpdateFrequency.QUARTERLY:
            case 4:
                return "QUARTERLY";
            case RemoteUrlUpdateFrequency.ANNUALLY:
            case 5:
                return "ANNUALLY";
            case RemoteUrlUpdateFrequency.HOURLY:
            case 6:
                return "HOURLY";
            case RemoteUrlUpdateFrequency.UNSPECIFIED:
            case -1:
                return "REMOTE_URL_UPDATE_FREQUENCY_UNSPECIFIED";
        }
    }
};
export var SuggestionType;
(function(SuggestionType) {
    SuggestionType["COMPETITION"] = "competition";
    SuggestionType["KERNEL"] = "kernel";
    SuggestionType["DATASET"] = "dataset";
    SuggestionType["CATEGORY"] = "category";
})(SuggestionType || (SuggestionType = {}));
export var SuggestionTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "SUGGESTION_TYPE_COMPETITION":
            default:
                return SuggestionType.COMPETITION;
            case "SUGGESTION_TYPE_KERNEL":
                return SuggestionType.KERNEL;
            case "SUGGESTION_TYPE_DATASET":
                return SuggestionType.DATASET;
            case "SUGGESTION_TYPE_CATEGORY":
                return SuggestionType.CATEGORY;
        }
    }
};
export var UpdateFeedbackType;
(function(UpdateFeedbackType) {
    UpdateFeedbackType["UNSPECIFIED"] = "unspecified";
    UpdateFeedbackType["ADD_VOTE"] = "addVote";
    UpdateFeedbackType["REMOVE_VOTE"] = "removeVote";
})(UpdateFeedbackType || (UpdateFeedbackType = {}));
export var UpdateFeedbackTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case UpdateFeedbackType.UNSPECIFIED:
            case 0:
            default:
                return "UPDATE_FEEDBACK_TYPE_UNSPECIFIED";
            case UpdateFeedbackType.ADD_VOTE:
            case 1:
                return "ADD_VOTE";
            case UpdateFeedbackType.REMOVE_VOTE:
            case 2:
                return "REMOVE_VOTE";
        }
    }
};
export var UserLicenseAgreementStatus;
(function(UserLicenseAgreementStatus) {
    UserLicenseAgreementStatus[// Default, unspecified.
    "UNSPECIFIED"] = "unspecified";
    UserLicenseAgreementStatus[// Users in this status are waiting for review from the 3rd-party. Users in
    // any specified status implicitly have consented to this review. The presence
    // of a ConsentTime value in the UserLicenseAgreements table explicitly
    // denotes if and when the user consented.
    "PENDING"] = "pending";
    UserLicenseAgreementStatus[// 3rd-party has approved the user's license agreement.
    "ACCEPTED"] = "accepted";
    UserLicenseAgreementStatus[// 3rd-party has rejected the user's license agreement.
    "REJECTED"] = "rejected";
})(UserLicenseAgreementStatus || (UserLicenseAgreementStatus = {}));
export var UserLicenseAgreementStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "USER_LICENSE_AGREEMENT_STATUS_UNSPECIFIED":
            default:
                return UserLicenseAgreementStatus.UNSPECIFIED;
            case "USER_LICENSE_AGREEMENT_STATUS_PENDING":
                return UserLicenseAgreementStatus.PENDING;
            case "USER_LICENSE_AGREEMENT_STATUS_ACCEPTED":
                return UserLicenseAgreementStatus.ACCEPTED;
            case "USER_LICENSE_AGREEMENT_STATUS_REJECTED":
                return UserLicenseAgreementStatus.REJECTED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case UserLicenseAgreementStatus.UNSPECIFIED:
            case 0:
            default:
                return "USER_LICENSE_AGREEMENT_STATUS_UNSPECIFIED";
            case UserLicenseAgreementStatus.PENDING:
            case 1:
                return "USER_LICENSE_AGREEMENT_STATUS_PENDING";
            case UserLicenseAgreementStatus.ACCEPTED:
            case 2:
                return "USER_LICENSE_AGREEMENT_STATUS_ACCEPTED";
            case UserLicenseAgreementStatus.REJECTED:
            case 3:
                return "USER_LICENSE_AGREEMENT_STATUS_REJECTED";
        }
    }
};
export var datasetsClient = {
    datasetDetailService: {
        getDatasetAdminSettings: createClient(GetDatasetAdminSettingsRequestWireFormat3, GetDatasetAdminSettingsResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetAdminSettings"),
        getDatasetBasics: createClient(GetDatasetBasicsRequestWireFormat3, DatasetBasicsWireFormat3, "datasets.DatasetDetailService/GetDatasetBasics"),
        getDatasetFeedbacks: createClient(GetDatasetFeedbacksRequestWireFormat3, GetDatasetFeedbacksResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetFeedbacks"),
        getDatasetImageInfo: createClient(GetDatasetImageInfoRequestWireFormat3, GetDatasetImageInfoResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetImageInfo"),
        getDatasetSettings: createClient(GetDatasetSettingsRequestWireFormat3, DatasetSettingsWireFormat3, "datasets.DatasetDetailService/GetDatasetSettings"),
        getDatasetUpvotes: createClient(GetDatasetUpvotesRequestWireFormat3, GetDatasetUpvotesResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetUpvotes"),
        getDatasetUsabilityRating: createClient(GetDatasetUsabilityRatingRequestWireFormat3, GetDatasetUsabilityRatingResponseWireFormat3, "datasets.DatasetDetailService/GetDatasetUsabilityRating"),
        // The next three RPCs are legacy and could potentially be merged with
        // GetDatasetBasics.
        // TODO(http://b/274833571): Move toward a Dataset proto/handler with mask
        // support, rather than these specific ones
        getDeletedDatasetInfo: createClient(GetDeletedDatasetInfoRequestWireFormat3, GetDeletedDatasetInfoResponseWireFormat3, "datasets.DatasetDetailService/GetDeletedDatasetInfo"),
        getDeletedDoiDatasetVersionInfo: createClient(GetDeletedDoiDatasetVersionInfoRequestWireFormat3, GetDeletedDoiDatasetVersionInfoResponseWireFormat3, "datasets.DatasetDetailService/GetDeletedDoiDatasetVersionInfo"),
        setDatasetSettings: createClient(SetDatasetSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetDetailService/SetDatasetSettings"),
        updateDatasetFeedbacks: createClient(UpdateDatasetFeedbacksRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetDetailService/UpdateDatasetFeedbacks"),
        updateDatasetImages: createClient(UpdateDatasetImagesRequestWireFormat3, UpdateDatasetImagesResponseWireFormat3, "datasets.DatasetDetailService/UpdateDatasetImages")
    },
    datasetService: {
        addDatasetCategories: createClient(AddDatasetCategoriesRequestWireFormat3, AddDatasetCategoriesResponseWireFormat3, "datasets.DatasetService/AddDatasetCategories"),
        consentToUserLicenseAgreement: createClient(ConsentToUserLicenseAgreementRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/ConsentToUserLicenseAgreement"),
        createBigQueryDataset: createClient(CreateBigQueryDatasetRequestWireFormat3, DatasetCreationResponseWireFormat3, "datasets.DatasetService/CreateBigQueryDataset"),
        createCompetitionData: createClient(CreateCompetitionDataRequestWireFormat3, CreateCompetitionDataResponseWireFormat3, "datasets.DatasetService/CreateCompetitionData"),
        createDataset: createClient(CreateDatasetRequestWireFormat3, DatasetCreationResponseWireFormat3, "datasets.DatasetService/CreateDataset"),
        createDatasetHashLink: createClient(CreateDatasetHashLinkRequestWireFormat3, CreateDatasetHashLinkResponseWireFormat3, "datasets.DatasetService/CreateDatasetHashLink"),
        createDatasetVersion: createClient(CreateDatasetVersionRequestWireFormat3, DatasetCreationResponseWireFormat3, "datasets.DatasetService/CreateDatasetVersion"),
        createDoi: createClient(CreateDoiRequestWireFormat3, CreateDoiResponseWireFormat3, "datasets.DatasetService/CreateDoi"),
        deleteDatasetBySlug: createClient(DeleteDatasetBySlugRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/DeleteDatasetBySlug"),
        deleteDatasetCategories: createClient(DeleteDatasetCategoriesRequestWireFormat3, DeleteDatasetCategoriesResponseWireFormat3, "datasets.DatasetService/DeleteDatasetCategories"),
        deleteDatasetHashLink: createClient(DeleteDatasetHashLinkRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/DeleteDatasetHashLink"),
        deleteDataViewerCacheEntryExternal: createClient(DeleteDataViewerCacheEntryExternalRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/DeleteDataViewerCacheEntryExternal"),
        detectDuplicate: createClient(DetectDuplicateRequestWireFormat3, DuplicationReferenceWireFormat3, "datasets.DatasetService/DetectDuplicate"),
        editDatasetDescription: createClient(EditDatasetDescriptionRequestWireFormat3, EditDatasetDescriptionResponseWireFormat3, "datasets.DatasetService/EditDatasetDescription"),
        getCompetitionUploaderConfig: createClient(GetCompetitionUploaderConfigRequestWireFormat3, CompetitionUploaderConfigWireFormat3, "datasets.DatasetService/GetCompetitionUploaderConfig"),
        getDatabundleVersionCreationStatus: createClient(GetDatabundleVersionCreationStatusRequestWireFormat3, DatabundleVersionCreationStatusWireFormat3, "datasets.DatasetService/GetDatabundleVersionCreationStatus"),
        getDatasetActivity: createClient(GetDatasetActivityRequestWireFormat3, ActivityPageWireFormat3, "datasets.DatasetService/GetDatasetActivity"),
        getDatasetByUrl: createClient(GetDatasetByUrlRequestWireFormat3, GetDatasetByUrlResponseWireFormat3, "datasets.DatasetService/GetDatasetByUrl"),
        getDatasetHistory: createClient(GetDatasetHistoryRequestWireFormat3, DatasetHistoryWireFormat3, "datasets.DatasetService/GetDatasetHistory"),
        getDatasetLimits: createClient(GetDatasetLimitsRequestWireFormat3, KaggleSdkCommonDiskUsageLimitsWireFormat3, "datasets.DatasetService/GetDatasetLimits"),
        getDatasetMetadata: createClient(GetDatasetMetadataRequestWireFormat3, DatasetMetadataWireFormat3, "datasets.DatasetService/GetDatasetMetadata"),
        getDatasetsById: createClient(GetDatasetsByIdRequestWireFormat3, DatasetListWireFormat3, "datasets.DatasetService/GetDatasetsById"),
        getDatasetSuggestions: createClient(GetDatasetSuggestionsRequestWireFormat3, GetDatasetSuggestionsResponseWireFormat3, "datasets.DatasetService/GetDatasetSuggestions"),
        getDatasetUploaderConfig: createClient(GetDatasetUploaderConfigRequestWireFormat3, DatasetUploaderConfigWireFormat3, "datasets.DatasetService/GetDatasetUploaderConfig"),
        getDataViewExternal: createClient(GetDataViewExternalRequestWireFormat3, KaggleSdkDatasetsDataViewerGetDataViewResponseWireFormat3, "datasets.DatasetService/GetDataViewExternal"),
        getGithubRepositoryInfo: createClient(GetGithubRepositoryInfoRequestWireFormat3, GetGithubRepositoryInfoResponseWireFormat3, "datasets.DatasetService/GetGithubRepositoryInfo"),
        getKernelOutputDataset: createClient(GetKernelOutputDatasetRequestWireFormat3, KernelOutputDatasetReferenceWireFormat3, "datasets.DatasetService/GetKernelOutputDataset"),
        getKernelOutputDataViewExternal: createClient(GetKernelOutputDataViewExternalRequestWireFormat3, KaggleSdkDatasetsDataViewerGetDataViewResponseWireFormat3, "datasets.DatasetService/GetKernelOutputDataViewExternal"),
        getLandingPageTopics: createClient(GetLandingPageTopicsRequestWireFormat3, GetLandingPageTopicsResponseWireFormat3, "datasets.DatasetService/GetLandingPageTopics"),
        // retrieve counts of the content that the user has created. This is used for
        // display on the User Profile > Dataset tab
        getProfileDatasetStats: createClient(GetProfileDatasetStatsRequestWireFormat3, GetProfileDatasetStatsResponseWireFormat3, "datasets.DatasetService/GetProfileDatasetStats"),
        getRecentlyViewedDatasets: createClient(GetRecentlyViewedDatasetsRequestWireFormat3, DatasetListWireFormat3, "datasets.DatasetService/GetRecentlyViewedDatasets"),
        getRemoteUrlFileInfo: createClient(GetRemoteUrlFileInfoRequestWireFormat3, RemoteUrlUploadFileWireFormat3, "datasets.DatasetService/GetRemoteUrlFileInfo"),
        getTopicalDatasets: createClient(GetTopicalDatasetsRequestWireFormat3, GetTopicalDatasetsResponseWireFormat3, "datasets.DatasetService/GetTopicalDatasets"),
        getUserLicenseAgreementStatus: createClient(GetUserLicenseAgreementStatusRequestWireFormat3, GetUserLicenseAgreementStatusResponseWireFormat3, "datasets.DatasetService/GetUserLicenseAgreementStatus"),
        // Sometime the databundle zipper would fail, this give moderator/host to
        // recreate the databundle zip file
        recreateDatasetArchive: createClient(RecreateDatasetArchiveRequestWireFormat3, RecreateDatasetArchiveResponseWireFormat3, "datasets.DatasetService/RecreateDatasetArchive"),
        refreshRemoteDataset: createClient(RefreshRemoteDatasetRequestWireFormat3, DatasetCreationResponseWireFormat3, "datasets.DatasetService/RefreshRemoteDataset"),
        searchDatasets: createClient(SearchDatasetsRequestWireFormat3, SearchDatasetsResponseWireFormat3, "datasets.DatasetService/SearchDatasets"),
        setDatabundleVersionNotes: createClient(SetDatabundleVersionNotesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SetDatabundleVersionNotes"),
        setDatasetCollaboratorList: createClient(SetDatasetCollaboratorListRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SetDatasetCollaboratorList"),
        softDeleteDatasetsForOrg: createClient(SoftDeleteDatasetsForOrgRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SoftDeleteDatasetsForOrg"),
        softDeleteDatasetsForUser: createClient(SoftDeleteDatasetsForUserRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/SoftDeleteDatasetsForUser"),
        updateDataset: createClient(UpdateDatasetRequestWireFormat3, UpdateDatasetResponseWireFormat3, "datasets.DatasetService/UpdateDataset"),
        updateDatasetCollaborators: createClient(UpdateDatasetCollaboratorsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/UpdateDatasetCollaborators"),
        updateDatasetGeneral: createClient(UpdateDatasetGeneralRequestWireFormat3, UpdateDatasetGeneralResponseWireFormat3, "datasets.DatasetService/UpdateDatasetGeneral"),
        updateDatasetMetadata: createClient(UpdateDatasetMetadataRequestWireFormat3, DatasetUsabilityRatingWireFormat3, "datasets.DatasetService/UpdateDatasetMetadata"),
        updateDatasetPrivacy: createClient(UpdateDatasetPrivacyRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/UpdateDatasetPrivacy"),
        validateGcsBucket: createClient(ValidateGcsBucketRequestWireFormat3, ValidateGcsBucketResponseWireFormat3, "datasets.DatasetService/ValidateGcsBucket"),
        voteOnDataset: createClient(VoteOnDatasetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "datasets.DatasetService/VoteOnDataset")
    }
};
